import React, { useState, useEffect, useRef, useMemo } from 'react';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    FormText,
    Container, Row, Col, Card, Table, CardBody, Label, Input, CardTitle, Button, FormGroup, Form,
    Collapse,
    Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel, CardHeader
} from 'reactstrap';

import { apiService } from '../../constants/ApiService';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
import CustomModal from '../../constants/CustomModal';
import { parse, v4 as uuidv4 } from 'uuid'
import moment from 'moment';
import AddItem from '../Item/AddItem';
import CreatePdf_Formate6 from '../Invoice/CreatePdf_Formate6.js';
import ErrorModal from '../../constants/ErrorModal.js';
import SpinnerLoader from '../../constants/SpinnerLoader.js';
import CustomerAddHelperMaster from '../../CustomModal/CustomerAddHelperMaster.jsx';
import AddParty from '../Party/AddParty.jsx';
import SingleItemArray from './SingleItemArray.jsx';
import RemarkPage from '../../constants/RemarkPage.js';
import Loader from '../../layouts/loader/Loader.js';
import { useSelector } from 'react-redux';
import { getInvoiceUrl } from '../../utils/commonUtilos.js';
// import PDFGeneratorButton from '../Invoice/createPdf.js';
const API_URL = process.env.REACT_APP_API_BASE_URL;



const AddChallanMaster = (props) => {

  const sessionData = useSelector((state) => state.sessionState);
    const location = useLocation();
    const navigate = useNavigate();
    const today = moment();
    const maxDate = today.format('YYYY-MM-DD'); // Maximum date is today
    const [showMode, setShowMode] = useState(false)
    const [uniqueId, setUniqueId] = useState('');
    const [partyTable, setPartyTable] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [locationTable, setLocationTable] = useState([]);
    const [removeNextChallanArray, setRemoveNextChallanArray] = useState([]);

    const [challanMasterData, setChallanMasterData] = useState({
        irflag: props?.irFlag,
        irflag_detail: props?.irflag_detail,
        challan_vendor_id: null,
        bill_date: sessionData.defaultDate,
        manual_billno: null,
        pname: '',
        add1: '',
        add2: '',
        add3_location: '',
        add2_city: '',
        add5_state: '',
        add6_pincode: null,
        addr_type: '',
        remark_note: '',
        session_year: sessionData.session_year,
        delivery_date: '',
        permit_no: '',
        contact_prs: '',
        contact_prs_ph: '',
        contact_prs_ph_no: '',
        contact_prs_whts_no: '',
        transporter_name: '',
        gr_no: '',
        vehicleno: '',
        driver_name: '',
        dl_no: '',
        reverse_charge: 'no',
        electronic_ref_no: '',
        tot_qty: null,
        gross_amt: null,
        apx_weight: null,
        apx_value: '',
        trip_no: 1,
        cart_amt: null,
        misc_exp_total: null,
        tax_amt: null,
        gst_type: '',
        gstno: null,
        net_amt: null,
        tax_code: 0,
        // select_address: false,

        station: '',
        cart_po_date: maxDate,
        cart_po_number: '',
        cart_transport_name: '',
        cart_fraight_topay_paid: 'topay',
        cart_amt_transporter: null,
        cart_per_tax_transporter: null,
        cart_amt_with_gst_transporter: null,
        cart_amt_final: null,
        cart_tcs_yn: 'no',
        // cart_transporter_cartage: "",
        // cart_amt_maintain_yn: "",
        // cart_tcs_percentage: null,
        // cart_tcs_value :null,

        // sale_method: "single_type",
        ch_status: "Completed",
        bill_match_yn: "Pending",

    });
    const [system_Records_Issue_Challan_data, setSystem_Records_Issue_Challan_data] = useState([]);

    const [openAccordion, setOpenAccordion] = useState(null);
    const [aggrementTable, setAggrementTable] = useState([]);
    const [partyMasterMultipleAddress, setPartyMasterMultipleAddress] = useState([])

    let initialChallanMisc = {
        //billno_automatic: null,
        pcode: null,
        pname: '',
        agr_code_old: '',
        ch_no: '',
        bill_date: null,
        exp_ac_name: '',
        exp_amt: null,
        exp_remarks: '',
        ir_flag: '',
        fo_oh: ''
    }
    const [challanMiscTransData, setChallanMiscTransData] = useState(initialChallanMisc)
    const [editMode, setEditMode] = useState(false)
    const [removeChallanBrokageData, setRemoveChallanBrokageData] = useState([]);
    let initialChallanBrokage = {
        rate: null,
        qty: null,
        amt: null,
        narr: '',
        damage: null,
        missing: null,
        item_name: ''
    }
    const [challanBrokageDetail, setChallanBrokageDetail] = useState(initialChallanBrokage)
    const [challanBrokageTable, setChallanBrokageTable] = useState([])
    const [challanMiscTransTable, setChallanMiscTransTable] = useState([])
    const [removeChallanMiscData, setRemoveChallanMiscData] = useState([]);
    const [challanBrokageModelTable, setChallanBrokageModelTable] = useState([])
    const [helperMasterChallanMisc, setHelperMasterChallanMisc] = useState([]);
    const [challanLastFiveRecord, setChallanLastFiveRecord] = useState([])
    const [challanId, setChallanId] = useState("");
    const [stateTable, setStateTable] = useState([]);
    const [cityTable, setCityTable] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [agreementShowMode, setAgreementShowMode] = useState(false)
    let initialAgreementData = {
        pname: "",
        pcode: null,
        pname_short_code: '',
        agr_code_old: '',
        agr_no_old: '',
        item_status_agr: '',
        item_code: null,
        item_short_name: '',
        item_name: '',
        item_group_code: null,
        item_group_name: '',
        mix_item_yes_no: '',
        item_loc: '',
        rent_rate: '',
        broken_chg: '',
        agr_qty: '',
        agr_date: null,
        opening_qty: '',
        rate_on_type: '',
        missing_rate: '',
        notaxrate: null,
        s_no: null,
        rate_of_one_pcs: "pc",
        weight_of_one_pcs: null,
        irflag: ""
    }
    const [agreementData, setAgreementData] = useState(initialAgreementData)
    const [itemTable, setItemTable] = useState([]);
    const [partyMasterName, setPartyMasterName] = useState("")
    const [partyMasterAgrCode, setPartyMasterAgrCode] = useState("")
    const [partyMasterId, setPartyMasterId] = useState("")
    const [System_Records_data, setSystem_Records_data] = useState([]);
    const [billMethod, setBillMethod] = useState("single")
    const [openWarrantyVisit, setOpenWarrantyVisit] = useState(false)
    const [warrantySlots, setWarrantySlots] = useState([]);
    const [warrantyArraySlots, setWarrantyArraySlots] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);


    const [removeWarrantyArraySlots, setRemoveWarrantyArraySlots] = useState([]);

    const [warrantySlotDetail, setWarrantySlotDetail] = useState({
        warranty_visit_charge: "no"
    });
    const [singleItemEditMode, setsingleItemEditMode] = useState(false)

    // single  aggrement


    const handleChange = (e) => {
        const { name, value } = e.target;


        // if (name == "roundoff_yn") {

        //     if (value == "yes") {
        //         setChallanMasterData(prevState => ({
        //             ...prevState,
        //             roundoff_amount: (Math.round(challanMasterData.amount_with_tcs) - challanMasterData.amount_with_tcs).toFixed(2),
        //             final_amount: Math.round(challanMasterData.amount_with_tcs)
        //         }));
        //     } else {
        //         setChallanMasterData(prevState => ({
        //             ...prevState,
        //             roundoff_amount: null,
        //             final_amount: challanMasterData.amount_with_tcs
        //         }));
        //     }
        // }
        if (name == "transport") {
            setChallanMasterData(prevState => ({
                ...prevState,
                transporter_name: value
            }));

        } 
        // else if (name == "manual_billno") {
        //     setChallanMasterData(prevState => ({
        //         ...prevState,
        //         [name]: value,
        //         //billno_automatic: value
        //     }));
        //} 
        else if (name == "sale_method") {
            setChallanMasterData(prevState => ({
                ...prevState,
                [name]: value,
                item_name: "",
                item_code: ""
            }));
        } else if (name == "add5_state") {

            let findArray = stateTable.find(data => data.state_Name == value);


            let branchData = branchMaster.find(data => data.id == challanMasterData.branch_master_id)
            let gstCode
            if (branchData.branch_state == findArray.state_Id) {
                gstCode = "SGST-CGST";

            } else {
                gstCode = "IGST"
            }

            setChallanMasterData(prevState => ({
                ...prevState,
                [name]: value,
                "add4_city": "",
                "addr_gst_type": gstCode,
                "state_code": findArray?.state_Code ? findArray?.state_Code : "",
                "gst_type": gstCode
            }));
        }
        else {
            setChallanMasterData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };


    // uue
    useEffect(() => {

        if (billMethod == "aggrement") {



            let cartAmount = parseFloat(challanMasterData.cart_amt) || 0

            // calculate the  challan aggrement item 
            const totalChallanAggrementRate = aggrementTable.reduce((acc, item) =>
                acc + ((item.rent_rate || 0) * (item.issue_qty || 0)),
                0);

            // const totalChallanAggrementRate = aggrementTable.reduce((acc, item) =>
            //     acc + ((item.itemMaster?.price_sell_rate || 0) * (item.issue_qty || 0)),
            //     0);


            // console.log(aggrementTable, "aggrementTableaggrementTable")
            // console.log(totalChallanAggrementRate, "totalChallanAggrementRatetotalChallanAggrementRatetotalChallanAggrementRate")

            const totalChallanAggrementWeight = aggrementTable.reduce((acc, item) =>
                acc + ((item.itemMaster?.price_avg_weight_per_pcs ?? 0) * (item.issue_qty ?? 0)),
                0);

            const totalChallanAggrementQty = aggrementTable.reduce((acc, item) =>
                acc + parseFloat(item.issue_qty || 0),
                0
            );

            // calculate the  challan Misc item 
            const totalChallanMiscRate = challanMiscTransTable.reduce((acc, item) =>
                acc + parseFloat(item.exp_amt || 0),
                0
            );

            // calcualte the cart tranport  
            let cartPerTaxTransporter = parseFloat(challanMasterData.cart_per_tax_transporter) / 100 || 0; // dividing by 100
            let cartAmtTransporter = parseFloat(challanMasterData.cart_amt_transporter) || 0;
            let cartAmountWithGst = cartPerTaxTransporter * cartAmtTransporter;

            //+ cartAmtTransporter

            // calculate the  amount without tax  
            let grossAmountBeforeTax = totalChallanAggrementRate + cartAmtTransporter


            // calculate the tax amount
            let taxAmount
            if (challanMasterData.tax_code) {
                let taxRate = parseFloat(challanMasterData.tax_code) / 100;
                taxAmount = (totalChallanAggrementRate) * taxRate;
            }


            // calculate the total gst tax amount 
            let gstTaxAmount
            if (challanMasterData.cart_transporter_cartage == "yes") {
                gstTaxAmount = parseFloat(taxAmount) || 0 + parseFloat(cartAmountWithGst) || 0
            } else {
                gstTaxAmount = parseFloat(taxAmount) || 0
            }

            // let taxAmount
            // if(challanMasterData.cart_transporter_cartage == "yes"){
            //     taxAmount = totalGstRate + cartAmountWithGst
            // }else{ 
            //     taxAmount = totalGstRate 
            // }


            // calculate amount with gst 
            let amountWithGst = parseFloat(taxAmount || 0) + parseFloat(grossAmountBeforeTax || 0) + parseFloat(cartAmountWithGst || 0)

            //calculate the  amount with  tcs value  
            let tcsAmount
            let tcsPercentage
            if (challanMasterData.cart_tcs_yn == "yes") {
                tcsPercentage = parseFloat(challanMasterData.cart_tcs_percentage || 0) / 100;
                tcsAmount = (amountWithGst) * tcsPercentage;
            } else {
                tcsAmount = null
                tcsPercentage = null
            }


            //calculate the amount with tcs 
            let amountWithTcs = parseFloat(amountWithGst || 0) + parseFloat(tcsAmount || 0)

            // Calculate the final amount
            let finalAmount = 0;
            let roundOffValue = 0;
            if (challanMasterData.roundoff_yn === "yes") {
                roundOffValue = Math.round(amountWithTcs) - amountWithTcs.toFixed(2);
                finalAmount = amountWithTcs + roundOffValue;
            } else {
                // If rounding off is not needed, finalAmount should be the amountWithTcs itself
                finalAmount = parseFloat(challanMasterData.amount_with_tcs || 0);
            }



            // let netAmount = ((parseFloat(taxAmount) || 0) + (parseFloat(cartAmountWithGst) || 0) + (parseFloat(totalChallanAggrementRate) || 0) + (parseFloat(totalChallanMiscRate) || 0) + (parseFloat(cartAmount) || 0)) + (parseFloat(cartAmtTransporter) || 0);


            setChallanMasterData(prevState => ({
                ...prevState,
                gross_amt: totalChallanAggrementRate,
                tot_qty: totalChallanAggrementQty,
                apx_weight: totalChallanAggrementWeight,
                misc_exp_total: totalChallanMiscRate,
                cart_amt_final: cartAmount + cartAmtTransporter,

                gross_amt_before_tax: grossAmountBeforeTax,
                tax_amt: gstTaxAmount,
                amount_with_gst: amountWithGst,

                cart_tcs_value: tcsAmount,
                amount_with_tcs: amountWithTcs,

                roundoff_amount: roundOffValue,
                final_amount: finalAmount,

                // net_amt: netAmount,


                // cartage transport key name
                cart_amt_with_gst_transporter: cartAmountWithGst + cartAmtTransporter,
                cart_tax_amount_transporter: cartAmountWithGst,
            }));

        }

    }, [challanMasterData.tax_code, challanMasterData.cart_amt,
        aggrementTable, challanMiscTransTable,
    challanMasterData.cart_amt_with_gst_transporter,
    challanMasterData.cart_per_tax_transporter,
    challanMasterData.cart_amt_transporter, challanMasterData.cart_tcs_yn,
    challanMasterData.cart_tcs_percentage,
    challanMasterData.amount_with_tcs, challanMasterData.cart_transporter_cartage
    ])

    const [itemMixedDetail, setItemMixedDetail] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");

    // select party name and related data
    const handleCusotmerName = (event, value) => {

        if (value) {

            const findAddressData = partyTable.find((data) => data.id === value.id);

            if (billMethod == "aggrement") {

                setAggrementTable([...findAddressData?.aggrementMaster])

                // Calculate totalOpeningQty for each item before rendering
                const updatedAggrementTable = findAddressData?.aggrementMaster.map(item => {
                    let totalOpeningQty = 0;
                    if (item.issueReceiptTransDetail?.length > 0) {
                        totalOpeningQty = item.issueReceiptTransDetail.reduce((acc, detail) => acc + (detail?.issue_qty ?? 0), 0);
                    }


                    console.log(totalOpeningQty, "totalOpeningQtytotalOpeningQtytotalOpeningQty")
                    // Return updated item with totalOpeningQty
                    return {
                        ...item,
                        opening_qty: parseFloat(totalOpeningQty) || 0 + parseFloat(item.opening_qty) || 0,
                        irflag: props?.irFlag
                    };
                });


                let ItemMixedDetailArray = [];  // Initialize an empty array

                findAddressData.aggrementMaster?.forEach((data) => {
                    if (data?.itemMaster?.itemTransMixDetail.length != 0) {
                        data.itemMaster.itemTransMixDetail.forEach((item) => {
                            if (item) {
                                // console.log(item,"item data ")
                                ItemMixedDetailArray.push(item);
                            }
                        });
                    }
                });

                setItemMixedDetail(ItemMixedDetailArray)

                // Update the state with the updatedAggrementTable
                setAggrementTable([...updatedAggrementTable]);

            }

            // setPartyMasterMultipleAddress(filteredData)
            setPartyMasterMultipleAddress([...findAddressData.partyAddressTransMaster]);
            setChallanMasterData(prevState => ({
                ...prevState,
                pname: findAddressData.name,
                pcode: findAddressData.id,
                agr_code_old: findAddressData.party_agr_code,
                // tax_code: findAddressData.percentage
                tds_option: findAddressData.tds_option,
                tds_master_id: findAddressData.tds_master_id,
                tds_rate: findAddressData.tds_rate
            }));

            setPartyMasterName(findAddressData.name)
            setPartyMasterId(findAddressData.id)
            setPartyMasterAgrCode(findAddressData.party_agr_code)

            // getItemData(1, 100000, "", findAddressData.id)

        } else {
            // setPartyMasterMultipleAddress([]);
            setChallanMasterData(prevState => ({
                ...prevState,
                pname: '',
                pcode: '',
                tax_code: null,
                tds_option: "",
                tds_master_id: null,
                tds_rate: null
            }));
            setSingleItemSelect(initialSingleItem)
            setSingleItemSelectArray([])
            setItemTable([])
            setPartyMasterName("")
            setPartyMasterId("")
        }
    };

    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };

    const debouncedGetPartyData = useMemo(() =>
        debounce((val) => {
            getPartyData(1, 100, val);
        }, 500),
        [challanMasterData]  // now it will capture latest challanMasterData
    );

    useEffect(() => {
        if (!editMode) {
            getItemData(1, 100000, "", challanMasterData.pcode)
        }
    }, [challanMasterData.pcode, challanMasterData.sale_method])



    //update irflag in aggrmenet array 
    const prevLengthRef = useRef(aggrementTable.length);
    useEffect(() => {
        // Check if a new object has been added
        if (aggrementTable.length != prevLengthRef.current) {
            const updatedData = aggrementTable.map(item => ({
                ...item,
                irflag: props?.irFlag
            }));
            setAggrementTable(updatedData);
            // Update the ref to the current length
            prevLengthRef.current = aggrementTable.length;
        }

    }, [aggrementTable.length != prevLengthRef.current]);

    // selct the part address data 
    const handleAddressName = (event, value) => {

        if (!value) {
            setChallanMasterData(prevState => ({
                ...prevState,
                add1: "",
                add2: "",
                add3_location: '',
                add4_city: "",
                add5_state: "",
                add6_pincode: "",
                addr_type: "",
                addr_gst_type: "",
                gstno: "",
                state_code: "",
                // select_address: false
            }));
            return
        }

        console.log(value.party_city, "party city data #########")


        setChallanMasterData(prevState => ({
            ...prevState,
            add1: value.party_address_1,
            add2: value.party_address_2,
            // add3_location: '',
            add3_location: value.party_address_location,
            add4_city: value.party_city,
            add5_state: value.party_state,
            add6_pincode: value.party_pincode.toString(),
            addr_type: value.party_address_description,
            addr_gst_type: value.party_gst_type,
            gstno: value.party_gst_address_no,
            state_code: value.party_gst_code,
            gst_type: value.party_gst_type,
            // select_address: true
        }));
    }

    const onHandleBackParty = () => {
        navigate(-1);
    };


    // this fucntion used for  get part data ina list 
    const getPartyData = async (page = 1, limit = 100000, search = "") => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            let queryParts = [];

            if (challanMasterData.vender_master_id) {
                queryParts.push(`party_branch_vendor_id=${challanMasterData.vender_master_id}`);
            }

            if (challanMasterData.branch_master_id) {
                queryParts.push(`party_branch_master_id=${challanMasterData.branch_master_id}`);
            }

            let query = queryParts.join("&");


            const response = await apiService.get(`/api/PartyMaster/allpartyList?pageNo=${page}&limit=${limit}&searchKey=${search}&${query}`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setPartyTable(response.partyMasterDetailData)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
        finally {
            // setPageLoading(prev => ({ ...prev, party: false }));
        }
    };

    const [transportNameList, setTransportNameList] = useState([])
    const [miscAccountList, setMiscAccountList] = useState([])


    const getPartyDataByGroupName = async (groupNames = [], flagname) => {
        try {
            if (groupNames.length === 0) {
                alert("No group names provided!");
                return;
            }

            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file uploads
                    'accept': 'application/json'
                }
            };

            const response = await apiService.post(
                `/api/PartyMaster/detailByGroupName`,
                groupNames,
                config
            );

            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);;
            }

            if (response.status === true) {
                if (flagname == "transport") {
                    setTransportNameList(response.partyMasterDetailData);
                }
                if (flagname == "misc") {
                    setMiscAccountList(response.partyMasterDetailData)
                }


            } else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error);
            toast.error(`SomeThing went wrong!!`);
        }
    };



    useEffect(() => {
        getPartyDataByGroupName(['CREDITORS'], "transport");
        getPartyDataByGroupName(['MISC. ACCOUNTS For Challan'], "misc");

        getPartyData();
    }, []);

    const { user } = useSelector((state) => state.authState);
    useEffect(() => {
        if (user.user_profile == "superadmin")
            getPartyData()
    }, [challanMasterData.vender_master_id, challanMasterData.branch_master_id])



    // this function used for validation
    const validateInputs = () => {
        const errors = {};

        if (!challanMasterData.vender_master_id) {
            errors.vender_master_id = 'Vender Name is required';
        }

        if (!challanMasterData.branch_master_id) {
            errors.branch_master_id = 'Branch Name is required';
        }




        if (!challanMasterData.bill_date) {
            errors.name = 'Bill Date is required';
        }
        if (!challanMasterData.manual_billno) {
            errors.manual_billno = 'Challan No. is required';
        }
        if (!challanMasterData.pname) {
            errors.pname = 'Party Name is required';
        }


        return errors;
    };


    // this function used for  address validation
    function checkAddress(obj) {

        const keysToCheck = [
            'add1',
            'add2',
            // 'add3_location', 
            'add4_city',
            'add5_state',
            'add6_pincode',
            'addr_type',
            'addr_gst_type',
            // 'gstno',
            'state_code'
        ];
        let isEmpty = false;
        // Loop through keys
        keysToCheck.forEach(key => {
            if (!obj.hasOwnProperty(key) || obj[key] === '') {
                isEmpty = true;
            }
        });
        return isEmpty
    }


    // genrate the random number with date and time and  second
    useEffect(() => {

        const myUUID = uuidv4();
        const date = new Date();
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getFullYear()}`;
        const formattedTime = `${date.getHours().toString().padStart(2, '0')}${date.getMinutes().toString().padStart(2, '0')}${date.getSeconds().toString().padStart(2, '0')}${date.getMilliseconds().toString().padStart(3, '0')}`;
        setUniqueId(`${myUUID}-${formattedDate}-${formattedTime}`)
    }, [!uniqueId])



    async function uploadImagesFromArrayWithIndex(array) {
        for (let i = 0; i < array.length; i++) {
            const obj = array[i];
            console.log("djddj")
            if (obj.upload_document_path && typeof obj.upload_document_path === 'object' && obj.upload_document_path !== null && 'name' in obj.upload_document_path) {
                try {
                    const imageUrl = await uploadImage(obj.upload_document_path);
                    obj.upload_document_path = imageUrl;
                } catch (error) {
                    console.error(`Error uploading image for index ${i}:`, error);
                }
            }
        }
    }


    async function uploadImage(image) {
        const uploadData = new FormData();
        uploadData.append('signature', image);

        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'accept': 'application/json'
            }
        };

        try {
            const response = await apiService.post("/api/CommonMaster/uploadfile", uploadData, config);
            if (response.status === true) {
                return response.data;
            } else {
                throw new Error("Invalid response from server");
            }
        } catch (error) {
            throw new Error("Failed to upload image: " + error.message);
        }
    }

    // insert/ create the  new challan data
    const AddChallanMasterData = async () => {

        // If already submitting, do nothing
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        const errors = validateInputs();
        if (Object.keys(errors).length > 0) {
            setErrorMessage(errors);
            setShowErrorModal(true)
            setIsSubmitting(false);

            return;
        }

        // let params = {
        //     ...challanMasterData,
        //     unique_number: uniqueId,
        //     // challanTrnKey: aggrementTable,
        //     // challanBreakageTransKey: challanBrokageTable,
        //     // challanMiscTranxKey: challanMiscTransTable
        // }

        let params = {
            ...challanMasterData,
            unique_number: uniqueId,
            // challanBreakageTransKey: challanBrokageTable,
            // challanMiscTranxKey: challanMiscTransTable
        };

        // Check if billMEHTIS is "AGGREMENT"
        if (billMethod === "aggrement") {
            params.challanTrnKey = aggrementTable;
            params.issueItemMixDetailKey = itemMixedDetail
        }


        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.post(`/api/IssueReceipt/create`, params, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                // setChallanMasterData(response.issueReceiptMasterDetailByID)
                setChallanMasterData((prevState) => ({
                    ...prevState,
                    bill_date: response.issueReceiptMasterDetailByID.bill_date,
                    manual_billno: response.issueReceiptMasterDetailByID.manual_billno,
                    pname: response.issueReceiptMasterDetailByID.pname,
                    id: response.issueReceiptMasterDetailByID.id,

                    sale_method: response.issueReceiptMasterDetailByID.sale_method,
                    item_code: response.issueReceiptMasterDetailByID.item_code,
                    item_name: response.issueReceiptMasterDetailByID.item_name,
                }));
                setEditMode(true)
                setErrorMessage("")

                setSaleMethod(response.issueReceiptMasterDetailByID.sale_method)

                if (response.issueReceiptMasterDetailByID.sale_method == "group_type") {
                    //console.log("item table", itemTable, 'item table data ')

                    const findItemData = itemTable.find((data) => data.id == response.issueReceiptMasterDetailByID.item_code);

                    const transformedArray = findItemData.itemTransMixDetail.map(({ item_qty, item_rate, ...rest }) => ({
                        ...rest,
                        issue_qty: item_qty,
                        rent_rate: item_rate
                    }));

                    setSingleItemSelectArray(transformedArray);
                    setItemTable(transformedArray)

                } else {
                    setItemMixedDetail(response.issueReceiptMasterDetailByID.issueItemMixDetailMaster)


                    if (billMethod == "aggrement") {
                        await setAggrementTable(response.issueReceiptMasterDetailByID.issueReceiptTransDetail)
                    }
                    if (billMethod == "single") {
                        await setSingleItemSelectArray(response.issueReceiptMasterDetailByID.issueReceiptTransDetail)
                    }


                    //  single item codntion working 
                    // automatcially add the item 

                    const updatedArray = [{ ...initialSingleItem }, ...singleItemSelectArray,];
                    const arrayWithSerials = updatedArray.map((item, index) => ({
                        ...item,
                        serial_no: String(index + 1)

                    }));
                    setSingleItemSelectArray(arrayWithSerials);
                }

            }
            else {

                getChallanByChallanId(response.issueReceiptMasterDetailByID.id)
                setEditMode(true)
                setErrorMessage("")

                // if (response.status === false) {

                //     // setChallanMasterData(response.issueReceiptMasterDetailByID)
                //     setChallanMasterData((prevState) => ({
                //         ...prevState,
                //         bill_date: response.issueReceiptMasterDetailByID.bill_date,
                //         manual_billno: response.issueReceiptMasterDetailByID.manual_billno,
                //         pname: response.issueReceiptMasterDetailByID.pname,
                //         id: response.issueReceiptMasterDetailByID.id,

                //         sale_method: response.issueReceiptMasterDetailByID.sale_method,
                //         item_code: response.issueReceiptMasterDetailByID.item_code,
                //         item_name: response.issueReceiptMasterDetailByID.item_name,
                //     }));

                //     setSaleMethod(response.issueReceiptMasterDetailByID.sale_method)

                //     setChallanBrokageTable(response.issueReceiptMasterDetailByID.issueReceiptBreakageTransDetail)
                //     setChallanMiscTransTable(response.issueReceiptMasterDetailByID.issueReceiptMiscTransDetail)
                //     // await setAggrementTable(response.issueReceiptMasterDetailByID.issueReceiptTransDetail)
                //     setEditMode(true)
                //     setErrorMessage("")

                //     if (billMethod == "aggrement") {
                //         await setAggrementTable(response.issueReceiptMasterDetailByID.issueReceiptTransDetail)
                //     }
                //     if (billMethod == "single") {
                //         await setSingleItemSelectArray(response.issueReceiptMasterDetailByID.issueReceiptTransDetail)
                //     }
                //     await setStockDetailTable(response.issueReceiptMasterDetailByID.issueItemExtraDetail)

                // }
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
        finally {
            setIsSubmitting(false); // Re-enable button
        }
    }


    const isObjectEmpty = (obj) => {
        for (let key in obj) {
            if (obj.hasOwnProperty(key) && (obj[key] !== null && obj[key] !== '' && obj[key] !== undefined)) {
                return false;
            }
        }
        return true;
    };

    const validateItemSelectArray = async (array) => {

        for (let i = 0; i < array.length; i++) {
            const item = array[i];
            const itemCodePresent = !!item?.item_code;
            const recvQty = parseFloat(item?.recv_qty || 0);
            const issueQty = parseFloat(item?.issue_qty || 0);
            const qtyPresent = recvQty > 0 || issueQty > 0;
            const sellRate = parseFloat(item.rent_rate || 0);




            if (!itemCodePresent && qtyPresent) {
                setErrorMessage({ singleItem: `Please select an item at row ${i + 1}.` });
                return false;
            }

            if (itemCodePresent && !qtyPresent && system_Records_Issue_Challan_data.ch_sig_item_qty_man_yn == "yes") {
                setErrorMessage({ singleItem: `Please enter quantity at row ${i + 1}.` });
                return false;
            }

            if (itemCodePresent && !sellRate && system_Records_Issue_Challan_data.ch_sig_item_rate_man_yn == "yes") {
                setErrorMessage({ singleItem: `Please enter Rate at row ${i + 1}.` });
                return false;
            }
        }

        return true;
    };



    // update challan data
    const UpdateChallanMasterData = async (challanId) => {

        // If already submitting, do nothing
        if (isSubmitting) {
            return;
        }

        if (challanMasterData.challan_by == "RECEIVE_CHALLAN") {
            return
        }

        setIsSubmitting(true);

        const isEmpty = isObjectEmpty(challanMiscTransData);
        if (!isEmpty) {
            alert("Please save the challan misc detail")
            return
        }


        // Filter the array immediately
        const filteredSingleItemArray = singleItemSelectArray.filter((item) => {
            const itemCodePresent = !!item?.item_code;
            const recvQty = parseFloat(item?.recv_qty || 0);
            const issueQty = parseFloat(item?.issue_qty || 0);
            const qtyPresent = recvQty > 0 || issueQty > 0;

            return itemCodePresent || qtyPresent;
        });

        setSingleItemSelectArray(filteredSingleItemArray);

        // check the  single item Array  
        const isValid = await validateItemSelectArray(filteredSingleItemArray);
        if (!isValid) {
            setIsSubmitting(false);
            setShowErrorModal(true)
            return;
        }

        await uploadImagesFromArrayWithIndex(remarkPageArrayList)

        try {


            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    accept: 'application/json',
                },
            };

            let params = {
                ...challanMasterData,
                pname_short_code: partyMasterAgrCode,
                challanTrnKey: aggrementTable,
                challanBreakageTransKey: challanBrokageTable,
                challanMiscTranxKey: challanMiscTransTable,
                removeChallanBreakageTransKey: removeChallanBrokageData,
                removeChallanMiscTransKey: removeChallanMiscData,
                ChallanSingleItemArrayKey: filteredSingleItemArray,
                IssueItemExtraDetailKey: stockDetailTable,
                RemoveChallanSingleItemArrayKey: deletesingleItemSelectArray,
                RemoveIssueItemExtraDetailKey: [],
                issueReceiptTransWarrantyArrayKey: warrantyArraySlots,
                RemoveIssueReceiptTransWarrantyArrayKey: removeWarrantyArraySlots,
                issueItemMixDetailKey: itemMixedDetail,
                CH_Remark_Upload_Detail_Key: remarkPageArrayList,
                CH_Remove_Remark_Upload_Detail_Key: deleteRemarkPageArrayList,
                removeNextChallanArray: removeNextChallanArray

            }

            // console.log(params, "params data for update");
            // return;


            const response = await apiService.put(
                `/api/IssueReceipt/update`,
                params,
                config
            );

            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);;
            }

            if (response.status === true) {
                toast.success(response.message);

                getChallanByChallanId(challanMasterData.id)
                setPrintMode(true);
                // window.location.reload();
                // navigate("/challan_issue")
                // setPrintMode(true)
            } else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error);
            toast.error(`SomeThing went wrong!!`);
        }
        finally {
            setIsSubmitting(false); // Re-enable button
        }
    }

    // this function is used for  get the chllan detail by chllan id
    const getChallanByChallanId = async (challanId) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/IssueReceipt/challanById?challanId=${challanId}`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {

                setPartyMasterName(response.issueReceiptMasterDetailByID.pname)
                setPartyMasterId(response.issueReceiptMasterDetailByID.pcode)
                setChallanMasterData(response.issueReceiptMasterDetailByID)
                setChallanBrokageTable(response.issueReceiptMasterDetailByID.issueReceiptBreakageTransDetail)
                setChallanMiscTransTable(response.issueReceiptMasterDetailByID.issueReceiptMiscTransDetail)
                setWarrantyArraySlots(response.issueReceiptMasterDetailByID.issueReceiptTransWarrantyDetail)
                setremarkPageArrayList(response.issueReceiptMasterDetailByID.remark_Upload_Detail)
                setChStatusList(response.issueReceiptMasterDetailByID.issueReceiptStatusHistoryTrans)

                if (billMethod == "aggrement") {
                    await setAggrementTable(response.issueReceiptMasterDetailByID.issueReceiptTransDetail)
                    await setItemMixedDetail(response.issueReceiptMasterDetailByID.issueItemMixDetailMaster)
                }
                if (billMethod == "single") {
                    await setSingleItemSelectArray(response.issueReceiptMasterDetailByID.issueReceiptTransDetail)
                }
                await setStockDetailTable(response.issueReceiptMasterDetailByID.issueItemExtraDetail)

                if (response.issueReceiptMasterDetailByID.sale_method == "group_type") {
                    getItemDataByItemId(response.issueReceiptMasterDetailByID.item_code);
                } else {
                    getItemData(1, 100000, "", response.issueReceiptMasterDetailByID.pcode);


                    //  automatically add item row
                    if (response.issueReceiptMasterDetailByID.issueReceiptTransDetail.length == 0) {
                        //  single item codntion working 
                        // automatcially add the item 

                        const updatedArray = [{ ...initialSingleItem }, ...singleItemSelectArray,];
                        const arrayWithSerials = updatedArray.map((item, index) => ({
                            ...item,
                            serial_no: String(index + 1)
                        }));
                        setSingleItemSelectArray(arrayWithSerials);
                    }
                }


                // const partyAddressTransMasterData = await Promise.all({
                //     const findAddressData = await partyTable.find((data) => data.name === challanData.pname);
                //     return findAddressData ? findAddressData.partyAddressTransMaster : null;

                // }
                // response.challanMasterDetailData.map(async (challanData) => {
                // })
                // );

                // const findAddressDataPromise = partyTable.find((data) => data.name === response.challanMasterDetailByID.pname)
                // .then((findAddressData) => {
                //     return findAddressData.partyAddressTransMaster;
                // });

                // const updatedTable = await Promise.all([findAddressDataPromise]);
                // setPartyMasterMultipleAddress(updatedTable)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }

    // this function is used for  get the  last 5 records
    const getChallanLastFiveRecord = async (challanId, flag, partyId) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            let url = location.state?.challanId ? `/api/IssueReceipt/lastFiveRecords?challanId=${challanId}&flag=${flag}&partyId=${partyId}` :
                "/api/IssueReceipt/lastFiveRecords"

            const response = await apiService.get(url, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setChallanLastFiveRecord(response.issueReceiptMasterDetailData)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }

    // function extractChallanIdFromUrl(url) {

    //     var parts = url.split("?");
    //     var queryParams = parts[1];
    //     var params = queryParams.split("&");
    //     var challanId;
    //     params.forEach(function (param) {
    //         var keyValue = param.split("=");
    //         if (keyValue[0] === "challanId") {
    //             challanId = keyValue[1];
    //         }
    //     });

    //     return challanId;
    // }



    // this function is used for  get the  last challan id
    const getLastChallanById = async (irFlag) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            let query = `/api/IssueReceipt/challanId?irFlag=${irFlag}`;
            if (user.user_profile === "superadmin" && challanMasterData.vender_master_id) {
                query += `&venderMasterId=${challanMasterData.vender_master_id ? challanMasterData.vender_master_id : null}`;
            }

            const response = await apiService.get(query, config);
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setChallanMasterData(prevState => ({
                    ...prevState,
                    manual_billno: String(response.lastId ? response.lastId + 1 : 0 + 1),
                    billno_automatic: response.lastId ? response.lastId + 1 : 0 + 1
                }));

                setErrorMessage("")

            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }


    // this fucntino used for get system records detail
    const Get_System_RecordsData = async (search) => {
        if (search == null) {
            search = ''
        }

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    accept: 'application/json',
                },
            };

            const response = await apiService.get(
                `/api/System_Records/GetSystem_Records?searchItem=${search}`,
                config
            );

            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);;
            }

            if (response.status === true) {
                setSystem_Records_data(response.data);
                setChallanMasterData(prevState => ({
                    ...prevState,
                    // cart_tcs_percentage: response.data[0]?.cart_tcs_value?.toFixed(3),
                    // cart_transporter_cartage: response.data[0]?.transporter_cartage_yn,
                    // cart_amt_maintain_yn: response.data[0]?.maintain_accounting_yn,
                    // roundoff_yn: response.data[0]?.round_off
                }));

                // setup invoice 
                setSystemInvoice(response.data[0].system_invoice)

                // single  aggrement
                // if (response.data[0].challan_master_method == "single") {
                //     setBillMethod("single")
                // }

                // if (response.data[0].challan_master_method == "aggrement") {
                //     setBillMethod("aggrement")
                // }
                // setBillMethod(response.data[0].challan_master_method)

            } else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error);
            alert('SomeThing went wrong')
        }
    };

    const getSystemRecordsWithFlag = async (flag) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/System_Records/GetSystem_RecordsByIdWithFlag?flag=${flag}`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setSystem_Records_Issue_Challan_data(response.system_RecordsDataById);
                setChallanMasterData(prevState => ({
                    ...prevState,
                    cart_tcs_percentage: response.system_RecordsDataById.cart_tcs_value?.toFixed(3),
                    cart_transporter_cartage: response.system_RecordsDataById.transporter_cartage_yn,
                    cart_amt_maintain_yn: response.system_RecordsDataById.maintain_accounting_yn,
                    trip_no: 1,
                    roundoff_yn: response.system_RecordsDataById.round_off
                }));

                // setup the  invoice 
                // setSystemInvoice(response.system_RecordsDataById.system_invoice)

                // single  aggrement
                if (response.system_RecordsDataById.challan_master_method == "single") {
                    setBillMethod("single")
                }

                if (response.system_RecordsDataById.challan_master_method == "aggrement") {
                    setBillMethod("aggrement")
                }
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }


    useEffect(() => {
        Get_System_RecordsData();
        getSystemRecordsWithFlag("issue_challan_single")

    }, [!System_Records_data]);



    useEffect(() => {
        const url = window.location.href;
        const flag = props.irFlag; // Default to "IC" if props.irFlag is undefined

        if (location.state) {
            // Case 1: Handle data from location.state
            getChallanLastFiveRecord(location.state.challanId, flag, location.state.partyId);
            getChallanByChallanId(location.state.challanId);
            setEditMode(true);
            setPrintMode(true);
        } else if (url.includes("?")) {
            // Case 2: Handle data from URL params
            const parts = url.split("?");
            const queryParams = parts[1];
            const params = queryParams?.split("&");
            let challanId;
            let partyId;

            params?.forEach((param) => {
                const [key, value] = param.split("=");
                if (key === "challanId") challanId = value;
                if (key === "partyId") partyId = value;
            });

            if (challanId) {
                setChallanId(challanId);
                getChallanLastFiveRecord(challanId, flag, partyId);
                getChallanByChallanId(challanId);
                setEditMode(true);
            }
        } else {
            // Case 3: Fallback if no params or state
            if (!challanMasterData.manual_billno) {
                getLastChallanById(flag);
            }
            // if (user.user_profile == "superadmin" && challanMasterData.vender_master_id) {
            //     getLastChallanById(flag);
            // }
            getChallanLastFiveRecord(null, flag, "");
        }
    }, [location.state, aggrementTable, billMethod, props.irFlag]);

    //     const url = window.location.href;

    //     if (location.state) {
    //         // Case 1: Handle data from location.state
    //         getChallanLastFiveRecord(location.state.challanId, "IC", location.state.partyId);
    //         getChallanByChallanId(location.state.challanId);
    //         setEditMode(true);
    //         setPrintMode(true);
    //     } else if (url.includes("?")) {
    //         // Case 2: Handle data from URL params
    //         const parts = url.split("?");
    //         const queryParams = parts[1];
    //         const params = queryParams?.split("&");
    //         let challanId;
    //         let partyId;

    //         params?.forEach((param) => {
    //             const [key, value] = param.split("=");
    //             if (key === "challanId") challanId = value;
    //             if (key === "partyId") partyId = value;
    //         });

    //         if (challanId) {
    //             setChallanId(challanId);
    //             getChallanLastFiveRecord(challanId, "IC", partyId);
    //             getChallanByChallanId(challanId);
    //             setEditMode(true);
    //         }
    //     } else {
    //         // Case 3: Fallback if no params or state
    //         if (!challanMasterData.manual_billno) {
    //             getLastChallanById("IC");
    //         }
    //         getChallanLastFiveRecord(null, "IC", "");
    //     }
    // }, [location.state, aggrementTable, billMethod]);


    const [irFlagState, setIrFlagState] = useState("")
    const [irFlagDetailState, setIrFlagDetailState] = useState("")

    useEffect(() => {
        const url = window.location.href;

        const flag = props.irFlag || "" // Default to "IC" if props.irFlag is undefined
        const irflag_detail = props.irflag_detail || "";

        setIrFlagState(flag);
        setIrFlagDetailState(irflag_detail);
        if (location.state) {
            // Case 1: Handle data from location.state
            getChallanLastFiveRecord(location.state.challanId, flag, location.state.partyId);
            getChallanByChallanId(location.state.challanId);
            setEditMode(true);
            setPrintMode(true);
        } else if (url.includes("?")) {
            // Case 2: Handle data from URL params
            const parts = url.split("?");
            const queryParams = parts[1];
            const params = queryParams?.split("&");
            let challanId;
            let partyId;

            params?.forEach((param) => {
                const [key, value] = param.split("=");
                if (key === "challanId") challanId = value;
                if (key === "partyId") partyId = value;
            });

            if (challanId) {
                setChallanId(challanId);
                getChallanLastFiveRecord(challanId, flag, partyId);
                getChallanByChallanId(challanId);
                setEditMode(true);
            }
        } else {
            // Case 3: Fallback if no params or state
            if (!challanMasterData.manual_billno) {
                getLastChallanById(flag);
            }

            // if (user.user_profile == "superadmin" && challanMasterData.vender_master_id) {
            //     getLastChallanById(flag);
            // }
            getChallanLastFiveRecord(null, flag, "");
        }
    }, [location.state, aggrementTable, billMethod, props.irFlag,]);

    useEffect(() => {
        const flag = props.irFlag || "" // Default to "RC" if props.irFlag is undefined
        if (user.user_profile == "superadmin" && challanMasterData.vender_master_id && !editMode) {
            getLastChallanById(flag);
        }
    }, [challanMasterData.vender_master_id, props.irFlag])

    const filteredData = partyTable.filter(item => item.name === challanMasterData?.pname);

    useEffect(() => {
        if (!challanMasterData?.pname || !partyTable) return;

        const filteredData = partyTable.filter(item => item.name === challanMasterData.pname);

        if (filteredData.length > 0 && filteredData[0]?.partyAddressTransMaster?.length > 0 && !editMode) {
            const addressData = filteredData[0].partyAddressTransMaster[0];

            setChallanMasterData(prevState => {
                const updatedState = {
                    ...prevState,
                    add1: addressData?.party_address_1 || "",
                    add2: addressData?.party_address_2 || "",
                    add3_location: addressData?.party_address_location || "",
                    add4_city: addressData?.party_city || "",
                    add5_state: addressData?.party_state || "",
                    add6_pincode: addressData?.party_pincode?.toString() || "",
                    addr_type: addressData?.party_address_description || "",
                    addr_gst_type: addressData?.party_gst_type || "",
                    gstno: addressData?.party_gst_address_no || "",
                    state_code: addressData?.party_gst_code || "",
                    gst_type: addressData?.party_gst_type || "",
                };

                console.log("Updated ChallanMasterData:", updatedState); // Debugging log
                return updatedState;
            });
        } else {
            if (!editMode) {
                setChallanMasterData(prevState => ({
                    ...prevState,
                    "gst_type": "SGST-CGST"
                }));
            }
        }
    }, [partyTable, challanMasterData?.pname]);

    // this code fucntion used for  challan Trans tran ( enter the item qty)
    const handleItemChange = (e, itemId, fieldName) => {


        // const updatedItems = aggrementTable.map(item =>
        //     item.id === itemId ? { ...item, [fieldName]: e.target.value } : item
        // );

        // new updated code
        const updatedItems = aggrementTable.map(item => {
            if (item.id === itemId) {
                const updatedItem = { ...item, [fieldName]: e.target.value };
                // Check if the field being changed is 'issue_qty'
                if (fieldName === 'issue_qty') {
                    // Update the rent_rate based on the qty value
                    // const rentRate = parseFloat(updatedItem.issue_qty) * parseFloat(updatedItem.itemMaster?.price_sell_rate || 0);
                    // updatedItem.rent_rate = rentRate;
                }
                return updatedItem;
            }
            return item;
        });
        setAggrementTable(updatedItems);
    };

    // this code fucntion used for  challan Misc tran

    const handleChallanMiscTransChange = (e) => {
        const { name, value } = e.target;
        setChallanMiscTransData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const AddChallanMiscData = () => {
        setChallanMiscTransTable(previous => [
            ...previous,
            challanMiscTransData
        ]);

        setChallanMiscTransData(initialChallanMisc);
    };

    const onRemoveChallanMiscData = (indexToRemove) => {
        setChallanMiscTransTable((prevTable) => {
            return prevTable.filter((_, index) => index !== indexToRemove);
        });

        setRemoveChallanMiscData(prevRemoveData => {
            const removedItem = challanMiscTransTable[indexToRemove];
            const updatedRemoveData = [...prevRemoveData, removedItem];
            return updatedRemoveData;
        });
    }


    const getState = async () => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/HelperMaster/allState`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setStateTable(response.state_Master)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }

    // get city
    const getCity = async (state) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            // let findArray = stateTable.find((data) => data.state_Name == state)
            // ?stateId=${findArray.state_Id}

            const response = await apiService.get(`/api/CityMaster/allCitys?page=1&limit=100000`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setCityTable(response.city_MasterDetailData)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }


    useEffect(() => {
        getCity();
        getState();
    }, [])

    // this code fucntion used for  challan brokage tans

    const handleChallanBrokageChange = (e) => {
        const { name, value } = e.target;
        setChallanBrokageDetail(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const AddChallanBrokageData = () => {
        // setChallanBrokageTable(previous => [
        //     ...previous,
        //     challanBrokageDetail
        // ]);

        setChallanBrokageModelTable(previous => [
            ...previous,
            challanBrokageDetail
        ]);

        // const total = [...challanBrokageTable, challanBrokageDetail].reduce((acc, item) => acc + (item.qty * item.rate), 0);
        // setChallanMasterData(prevState => ({
        //     ...prevState,
        //     manual_billno: total
        // }));

        setChallanBrokageDetail(prevState => ({
            ...prevState,
            rate: null,
            qty: null,
            amt: null,
            narr: '',
            damage: null,
            missing: null,
            // item_name: ''
        }));
    };

    const onRemoveChallanBrokageData = (indexToRemove) => {
        setChallanBrokageTable((prevTable) => {
            return prevTable.filter((_, index) => index !== indexToRemove);
        });

        setChallanBrokageModelTable((prevTable) => {
            return prevTable.filter((_, index) => index !== indexToRemove);
        });

        setRemoveChallanBrokageData(prevRemoveData => {
            const removedItem = challanBrokageTable[indexToRemove];
            const updatedRemoveData = [...prevRemoveData, removedItem];
            return updatedRemoveData;
        });
    };

    const openModal = (id, itemName) => {
        // const filteredData = aggrementTable.filter(item => item.id == id);

        // setup the challan brokage detail data
        setChallanBrokageDetail(prevState => ({
            ...prevState,
            challan_trans_id: id,
            // unique_number: uniqueId,
            item_name: itemName
        }));


        // find the challan brokage detail acc to item id

        const filteredData = challanBrokageTable.filter(item => item.item_name == itemName);
        setChallanBrokageModelTable(previous => [
            ...previous,
            ...filteredData
        ]);


        // const filteredData = challanBrokageTable.filter(item => item.challan_trans_id == id);
        // setChallanBrokageModelTable(previous => [
        //     ...previous,
        //     ...filteredData
        // ]);

        setShowMode(true);
    };


    const closeModal = () => {
        setChallanBrokageModelTable([]);
        setShowMode(false);
        setChallanBrokageDetail(prevState => ({
            ...prevState,
            rate: null,
            qty: null,
            amt: null,
            narr: '',
            damage: null,
            missing: null,
            item_name: ''
        }));
    };

    const confirmModal = () => {
        setShowMode(false);
        setChallanBrokageModelTable([]);
        setChallanBrokageTable(previous => [
            ...previous,
            ...challanBrokageModelTable
        ]);
    }

    const [showMixedModel, setShowMixedModel] = useState(false);
    const [showMixedList, setShowMixedList] = useState([]);

    const openMixedDetailModal = (id, itemName) => {
        let findArray = itemMixedDetail.filter((data) => data.item_master_id == id);
        setShowMixedModel(true)
        setShowMixedList(findArray)
    }

    const closedMixedDetailModal = () => {
        setShowMixedModel(false)

    }

    const confirmMixedDetailModal = () => {

    }




    const toggleAccordion = (index) => {
        setOpenAccordion((prevIndex) => (prevIndex === index ? null : index));
    };

    const getHelperMasterChallanMiscTable = async (formName) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setHelperMasterChallanMisc(response.helperMasterData)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }


    useEffect(() => {
        // getHelperMasterChallanMiscTable("challan_misc_type")
    }, [])



    function openNewTab(challanId, partyId) {
        const url = `${window.location.origin}/add_challan_issue?challanId=${challanId}&partyId=${partyId}`;
        window.open(url, '_blank');
    }




    /// ===============================  New Agreement Custom Model Function  ============================ ///

    const openAgrementCustomerModal = () => {
        setAgreementShowMode(true)
        getItemData()
    }

    const handleOptionSelect = async (event, value) => {

        if (value === null || value === undefined) {
            setAgreementData(initialAgreementData)
            return;
        }

        let findData = itemTable.find((data) => data.id == value.id)
        await setAgreementData((prevData) => ({
            ...prevData,
            pname: partyMasterName,
            pcode: partyMasterId,
            party_master_id: partyMasterId,
            item_short_name: findData?.item_code,
            item_name: findData?.item_name,
            agr_date: new Date(),
            notaxrate: findData?.tax_per ? findData?.tax_per : null,
            item_group_name: findData?.group,
            weight_of_one_pcs: findData?.price_avg_weight_per_pcs ? findData?.price_avg_weight_per_pcs : null,
            rate_of_one_pcs: "pc",
            item_code: findData?.id ? findData?.id : null,
            agr_qty: 0,
            rent_rate: 0,
            missing_rate: 0,
            broken_chg: 0,
            opening_qty: findData?.price_opening_stock_rate,

            pname: partyMasterName ? partyMasterName : "",
            pcode: partyMasterId ? partyMasterId : null,
            itemtype: findData.item_type ? findData.item_type : "",
            item_group_code: findData.group_id ? findData.group_id : null,
            mix_item_yes_no: findData?.mix_item_yes_no,
            rent_rate: findData.price_sell_rate


        }));


        if (billMethod == "aggrement") {

            let ItemMixedDetailArray = [];  // Initialize an empty array

            if (findData?.itemTransMixDetail.length != 0) {
                findData.itemTransMixDetail.forEach((item) => {
                    if (item) {
                        ItemMixedDetailArray.push(item);
                    }
                });
            }


            setItemMixedDetail(ItemMixedDetailArray)
        }
    };

    const onChangeHandle = (e) => {

        const { name, value } = e.target
        setAgreementData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const getItemData = async (page = 1, limit = 100000, search = "", partyId = "") => {

        // alert(" run this fucntinon item kmaster ")
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            let url = `/api/ItemMaster/allitem?pageNo=${page}&limit=${limit}&searchKey=${search}&partId=${partyId}`;

            if (challanMasterData.sale_method == "group_type") {
                url += `&mix_item_option=yes`;  // Append saleMethod as a query parameter
            }

            const response = await apiService.get(url, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setItemTable(response.itemMasterDetailData)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    };

    // useEffect(() => {
    //     getItemData()
    // }, [])



    const closeAgrementCustomerModal = () => {
        setAgreementData(initialAgreementData)
        setAgreementShowMode(false);
        // setNewItemData(initialItem)
    };

    const confirmAgrementCustomerModal = async () => {
        setAgreementShowMode(false);

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.post(`/api/AgreementDetail/create`, agreementData, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                aggrementTable.push(response.aggrementMasterDetailByID)
                setAgreementData(initialAgreementData)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }




    // this function is used for  single item selected 

    let initialSingleItem = {
        item_code: null,
        item_name: "",
        group: "",
        hsn_code: "",
        tax_per: "",
        convertion_of_pcs: "",
        price_purchase_rate: null,
        price_sell_rate: null,
        price_avg_weight_per_pcs: null,
        price_opening_stock_rate: null,
        opening_stock_shop: null,
        stock_shop: null,
        opening_stock_godown: null,
        stock_godown: null,
        total_stock: null,
        item_type: "",
        recv_qty: 0,
        issue_qty: 0,
        item_gross_amount_one_pc: "",
        item_gst: "",
        item_gst_rate_one_pc: "",
        total_amount_with_gst_one_pc: "",
        item_hsn_code_one_pc: '',
        item_packing_type_one_pc: '',
        item_remarks_one_pc: '',

        item_gst_percenatge_one_pc: "",
        item_discount_rate_one_pc: "",
        rent_rate: "",
        item_discount_percentage_one_pc: "",
        rent_rate: "",
        item_weight_one_pc: null,
        itemWeight: null,
        irflag: props?.irFlag,
        item_scheme_type_one_pc: "",
        pname: "",
        pcode: null,
        itemtype: "",
        item_group_code: null
    }
    const [singleItemSelect, setSingleItemSelect] = useState(initialSingleItem)
    const [singleItemSelectArray, setSingleItemSelectArray] = useState([])
    const [deletesingleItemSelectArray, setDeletesingleItemSelectArray] = useState([])


    function calculateWarrantyExpiryDate(condition) {
        let currentDate = new Date();

        // Log the current date
        console.log("Current Date:", currentDate);

        // Initialize expiry date as the current date
        let expiryDate = new Date(currentDate);

        // Parse condition for months and years
        const match = condition.match(/(\d+)\s*(Months?)/i);
        const year = condition.match(/(\d+)\s*(Years?)/i);

        // Check for months
        if (match) {
            let value = parseInt(match[1], 10); // Extract numeric value for months
            expiryDate.setMonth(expiryDate.getMonth() + value);
        }

        // Check for years
        if (year) {
            let value = parseInt(year[1], 10); // Extract numeric value for years
            expiryDate.setFullYear(expiryDate.getFullYear() + value);
        }

        // Format the date to YYYY-MM-DD for input tag
        let formattedDate = expiryDate.toISOString(); // Get date in YYYY-MM-DD format

        console.log("Expiry Date:", formattedDate);
        return formattedDate;
    }



    const onChangeSingleItemHandle = (e) => {
        const { name, value } = e.target;

        console.log(name, value)

        if (name == "item_warranty_period") {

            setSingleItemSelect((prevData) => ({
                ...prevData,
                [name]: value,
                item_warranty_expiry_date: calculateWarrantyExpiryDate(value)
            }));

        } else {
            setSingleItemSelect((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };



    const handleSingleItem = (event, value) => {

        if (value === null || value === undefined) {
            setSingleItemSelect(initialSingleItem)
            return;
        }

        const findItemData = itemTable.find((data) => data.id === value.id);
        let totalOpeningQty = 0;
        if (findItemData?.challanTransDetail?.length > 0) {
            totalOpeningQty = findItemData?.challanTransDetail.reduce((acc, detail) => acc + (detail?.issue_qty ?? 0), 0);
        }

        if (findItemData) {
            setSingleItemSelect((prevState) => ({
                ...prevState,
                ...findItemData,
                // rent_rate: findItemData.price_sell_rate,
                // item_purchase_one_pc: findItemData.price_purchase_rate,
                // item_profit_one_pc: findItemData.price_sell_rate - findItemData.price_purchase_rate,


                rent_rate: findItemData.price_sell_rate ? findItemData.price_sell_rate : 0,
                item_purchase_one_pc: findItemData.price_purchase_rate ? findItemData.price_purchase_rate : 0,
                item_profit_one_pc: (findItemData.price_sell_rate ? findItemData.price_sell_rate : 0) - (findItemData.price_purchase_rate ? findItemData.price_purchase_rate : 0),
                item_hsn_code_one_pc: findItemData.hsn_code ? findItemData.hsn_code : "",
                item_packing_type_one_pc: findItemData.item_packing_type ? findItemData.item_packing_type : "",

                item_discount_percentage_one_pc: findItemData.price_sell_discount_percentage ? findItemData.price_sell_discount_percentage : null,
                item_gst_percenatge_one_pc: findItemData.price_sell_gst_percentage ? findItemData.price_sell_gst_percentage : null,
                item_weight: findItemData.price_avg_weight_per_pcs ? findItemData.price_avg_weight_per_pcs : "",
                item_code: findItemData.id ? findItemData.id : null,
                item_group_name: findItemData.group ? findItemData.group : "",
                item_current_stock: findItemData.total_stock ? findItemData.total_stock : 0,
                opening_qty: totalOpeningQty,
                pname: partyMasterName,
                pcode: partyMasterId,
                itemtype: findItemData.item_type ? findItemData.item_type : "",
                item_group_code: findItemData.group_id ? findItemData.group_id : null,
                item_scheme_type_one_pc: "chargeable",




                item_warranty_mode: "",
                item_warranty_period: findItemData.warranty_period ? findItemData.warranty_period : "",
                item_warranty_visit_count: "",
                item_warranty_expiry_date: findItemData.warranty_yes_no == "yes" ? calculateWarrantyExpiryDate(findItemData.warranty_period) : null
            }));
        }
    }

    const AddSingleItemSelect = () => {
        // Check if itemData is not empty
        if (Object.keys(singleItemSelect).length !== 0) {


            // let existingItem = singleItemSelectArray.find((data) => data.item_code === singleItemSelect.id);
            // if (existingItem) {
            //     alert("This item already exists. Please edit the existing entry if needed.");
            // }


            let findItemIndex = singleItemSelectArray.findIndex((data) => data.id === singleItemSelect.id);
            if (findItemIndex !== -1) {

                let findItemDetail = singleItemSelectArray.find((data) => data.id === singleItemSelect.id && data.data_mode === "old");
                if (findItemDetail) {


                    if (findItemDetail.issue_qty > singleItemSelect.issue_qty) {

                        const updatedItemArray = [...singleItemSelectArray];

                        updatedItemArray[findItemIndex] = {
                            ...updatedItemArray[findItemIndex],
                            issue_qty: parseFloat(singleItemSelect.issue_qty),
                            // item_gross_amount_one_pc: parseFloat(singleItemSelect.item_gross_amount_one_pc),
                            // item_gst_rate_one_pc: parseFloat(singleItemSelect.item_gst_rate_one_pc),
                            // total_amount_with_gst_one_pc: parseFloat(singleItemSelect.total_amount_with_gst_one_pc)
                        };
                        setSingleItemSelectArray(updatedItemArray);


                    } else {

                        const updatedItemArray = [...singleItemSelectArray];

                        updatedItemArray[findItemIndex] = {
                            ...updatedItemArray[findItemIndex],
                            issue_qty: parseFloat(updatedItemArray[findItemIndex].issue_qty) + parseFloat(singleItemSelect.issue_qty),
                            // item_gross_amount_one_pc: parseFloat(updatedItemArray[findItemIndex].item_gross_amount_one_pc) + parseFloat(singleItemSelect.item_gross_amount_one_pc),
                            // item_gst_rate_one_pc: parseFloat(updatedItemArray[findItemIndex].item_gst_rate_one_pc) + parseFloat(singleItemSelect.item_gst_rate_one_pc),
                            // total_amount_with_gst_one_pc: parseFloat(updatedItemArray[findItemIndex].total_amount_with_gst_one_pc) + parseFloat(singleItemSelect.total_amount_with_gst_one_pc)
                        };
                        setSingleItemSelectArray(updatedItemArray);

                    }

                } else {

                    const updatedItemArray = [...singleItemSelectArray];
                    updatedItemArray[findItemIndex] = {
                        ...updatedItemArray[findItemIndex],
                        issue_qty: parseFloat(updatedItemArray[findItemIndex].issue_qty) + parseFloat(singleItemSelect.issue_qty),
                        // item_gross_amount: parseFloat(updatedItemArray[findItemIndex].item_gross_amount) + parseFloat(singleItemSelect.item_gross_amount),
                        // item_gst_rate: parseFloat(updatedItemArray[findItemIndex].item_gst_rate) + parseFloat(singleItemSelect.item_gst_rate),
                        // total_amount_with_gst: parseFloat(updatedItemArray[findItemIndex].total_amount_with_gst) + parseFloat(singleItemSelect.total_amount_with_gst)
                    };
                    setSingleItemSelectArray(updatedItemArray);
                }

            } else {
                // Item doesn't exist in the array, add it
                setSingleItemSelectArray((prevItems) => [...prevItems, { ...singleItemSelect, data_mode: "old" }]);
            }
            // Reset itemData to its initial state
            setSingleItemSelect(initialSingleItem);
        }

        setsingleItemEditMode(false)
        // setItemSelectedItem((prevSelectedItems) => {
        //     const newTotalAmount = calculateTotalAmount(prevSelectedItems);
        //     setTotalAmount(newTotalAmount);
        //     return prevSelectedItems; // Return the updated state
        // });
    };



    const RemoveSingleItemSelect = (id) => {

        setSingleItemSelectArray((prevState) => {

            const itemToRemove = prevState.find((item) => item.id === id);
            const updatedArray = prevState.filter((item) => item.id !== id);
            if (itemToRemove) {
                setDeletesingleItemSelectArray((prevDeleteState) => [...prevDeleteState, itemToRemove]);
            }
            return updatedArray;
        });


        let findItemDetail = singleItemSelectArray.find((data) => data.id == id)
        setWarrantyArraySlots((prevState) => {

            const itemsToRemove = prevState.filter((item) => item.item_code === findItemDetail.itemMaster.id);
            const updatedArray = prevState.filter((item) => item.item_code !== findItemDetail.itemMaster.id);
            if (itemsToRemove.length > 0) {
                setRemoveWarrantyArraySlots((prevDeleteState) => [...prevDeleteState, ...itemsToRemove]);
            }

            return updatedArray;
        });

    }





    const EditSingleItemSelect = (itemId) => {
        let findArray = singleItemSelectArray.find((data) => data.id == itemId)
        setSingleItemSelect(findArray)

        setSingleItemSelectArray((prevState) => {

            const itemToRemove = prevState.find((item) => item.id === itemId);
            const updatedArray = prevState.filter((item) => item.id !== itemId);
            return updatedArray;
        });
        setsingleItemEditMode(true)

    }
    function isNumber(value) {
        return typeof value === 'number' && !isNaN(value);
    }

    //vve
    useEffect(() => {
        if (billMethod == "single") {


            const qty = parseFloat(singleItemSelect.issue_qty);
            const sellRate = parseFloat(singleItemSelect.rent_rate);
            const discountPercent = parseFloat(singleItemSelect.item_discount_percentage_one_pc) || 0
            const profit = parseFloat(singleItemSelect.rent_rate - singleItemSelect.item_purchase_one_pc) || 0;
            let itemWeight = parseFloat(singleItemSelect.item_weight)


            // // calculate the total wt acc to qty
            let totalWeight = qty ? (itemWeight * qty) || 0 : itemWeight
            // if(qty){
            //     totalWeight = qty ? itemWeight * qty : itemWeight
            // }


            // amount calculate after discount  
            const totalBeforeDiscount = qty * sellRate;
            const discountAmount = (totalBeforeDiscount * discountPercent) / 100;
            const totalAfterDiscount = totalBeforeDiscount - discountAmount;


            // discount amount 
            const discountAmt = (sellRate * discountPercent) / 100

            // discount rate 
            // const discountRate = singleItemSelect.price_sell_rate - discountAmt
            const discountRate = discountPercent * discountAmt

            // total  gross amount 
            const grossAmount = parseFloat(totalBeforeDiscount || 0) - parseFloat(discountAmount || 0);

            // Calculate amount with gst
            const gstPercent = parseFloat(singleItemSelect.item_gst_percenatge_one_pc) || 0;
            const gstAmount = (grossAmount * gstPercent) / 100;
            //  const totalAmountWithGST = grossAmount + gstAmount;

            // calculate Gst Amount
            let itemGstAmount = (gstPercent * parseFloat(singleItemSelect.item_discount_rate_one_pc) || 0) / 100;


            // Update singleItemSelect with new calculated values
            setSingleItemSelect((prevData) => ({
                ...prevData,

                item_profit_one_pc: profit,
                profit_amount_one_pc: (qty * profit || 0),
                item_gross_amount_one_pc: parseFloat(totalBeforeDiscount || 0) - parseFloat(discountAmount || 0),
                item_discount_amount_one_pc: discountAmt.toFixed(2),
                item_discount_rate_one_pc: discountRate.toFixed(2),

                item_rate_after_gst_one_pc: parseFloat(discountRate || 0) + parseFloat(itemGstAmount || 0),

                item_gst_percenatge_one_pc: gstPercent,
                item_gst_rate_one_pc: gstAmount.toFixed(2),
                item_gst_amt_one_pc: itemGstAmount,
                total_amount_with_gst_one_pc: parseFloat(totalBeforeDiscount || 0) - parseFloat(discountAmount || 0) + parseFloat(gstAmount || 0),
                item_weight_one_pc: totalWeight

            }));
        }

    }, [singleItemSelect.issue_qty, singleItemSelect.rent_rate,
    singleItemSelect.item_discount_percentage_one_pc, singleItemSelect.item_gst_percenatge_one_pc])


    // vve1
    useEffect(() => {

        if (billMethod == "single") {

            // if (singleItemSelectArray.length != 0) {

            // calculate the  total wt
            const totalItemWt = singleItemSelectArray.reduce((acc, item) =>
                acc + (parseFloat(item.item_weight_one_pc || 0) * parseFloat(item.issue_qty || 0)),
                0);

            // calculate the total qty
            const totalItemQty = singleItemSelectArray.reduce((acc, item) =>
                acc + (parseFloat(item.issue_qty || 0)),
                0);


            // calculate the  chllan misc amount     
            const totalChallanMiscRate = challanMiscTransTable.reduce((acc, item) =>
                acc + parseFloat(item.exp_amt || 0),
                0
            );

            // calculate the total gross amount
            const totalGrossAmount = singleItemSelectArray.reduce((acc, item) =>
                acc + ((item.item_gross_amount_one_pc || 0)),
                0);

            // calculate the gst amount
            const totalGstRate = singleItemSelectArray.reduce((acc, item) =>
                acc + (parseFloat(item.item_gst_rate_one_pc || 0)),
                0);

            // calculate the amount with gst
            const totalAmountWithGst = singleItemSelectArray.reduce((acc, item) =>
                acc + ((item.total_amount_with_gst_one_pc || 0)),
                0);


            // calculate the  total Count
            const totalItemCount = singleItemSelectArray.length != 0 ? singleItemSelectArray.length : 0;

            // }

            // calcualte the cart tranport  
            let cartPerTaxTransporter = parseFloat(challanMasterData.cart_per_tax_transporter) / 100 || 0; // dividing by 100
            let cartAmtTransporter = parseFloat(challanMasterData.cart_amt_transporter) || 0;
            let cartAmountWithGst = cartPerTaxTransporter * cartAmtTransporter;

            // calculate the total tax amount

            let taxAmount
            if (challanMasterData.cart_transporter_cartage == "yes") {
                taxAmount = totalGstRate + cartAmountWithGst
            } else {
                taxAmount = totalGstRate
            }


            // calculate the  total gst amount 
            const amountWithGst = totalAmountWithGst + cartAmtTransporter + cartAmountWithGst



            // setChallanMasterData(prevState => ({
            //     ...prevState,
            //     cart_tcs_percentage: response.data[0].cart_tcs_value.toFixed(3)
            // }));

            //calculate the  amount with  tcs value  
            let tcsAmount
            let tcsPercentage
            if (challanMasterData.cart_tcs_yn == "yes") {

                let taxPer = challanMasterData.cart_tcs_percentage ? parseFloat(challanMasterData.cart_tcs_percentage || 0) : System_Records_data?.cart_tcs_value?.toFixed(3)
                tcsPercentage = parseFloat(taxPer) / 100;
                tcsAmount = (amountWithGst) * tcsPercentage;
            } else {
                tcsAmount = null
                tcsPercentage = null
            }


            //calculate the amount with tcs  ====  // calculate the final amount 

            let amountWithTcs = parseFloat(amountWithGst || 0) + parseFloat(tcsAmount || 0)



            //calculate the amount with tds == calculate the final amount
            let tdsAmount = 0;
            if (challanMasterData.tds_option == "yes") {
                // tdsAmount = parseFloat(challanMasterData.tds_rate || 0) * parseFloat(totalGrossAmount || 0);
                tdsAmount = (parseFloat(challanMasterData.tds_rate || 0) / 100) * parseFloat(totalGrossAmount || 0);

            }

            // Calculate the final amount
            let finalAmount = 0;
            let roundOffValue = 0;

            if (challanMasterData.roundoff_yn == "yes") {
                roundOffValue = Math.round(amountWithTcs) - amountWithTcs.toFixed(2);
                finalAmount = amountWithTcs + roundOffValue - tdsAmount;
            } else {
                // If rounding off is not needed, finalAmount should be the amountWithTcs itself
                finalAmount = parseFloat(challanMasterData.amount_with_tcs || 0) - parseFloat(tdsAmount || 0);
            }


            //  add new condition for check manaual Data & system Data

            const manualItemCount = parseFloat(challanMasterData.item_count_manual);
            const manualQty = parseFloat(challanMasterData.total_qty_manual);
            const manualAmt = parseFloat(challanMasterData.total_amt_manual);

            const systemItemCount = parseFloat(totalItemCount);
            const systemQty = parseFloat(totalItemQty);
            const systemAmt = parseFloat(finalAmount);

            let isMismatch = false;

            // Group 1: Check item count 
            if (!isNaN(manualItemCount) && !isNaN(systemItemCount)) {
                if (manualItemCount !== systemItemCount) {
                    isMismatch = true;
                }
            }

            // Group 2: Check amount 
            if (!isNaN(manualAmt) && !isNaN(systemAmt)) {
                if (manualAmt !== systemAmt) {
                    isMismatch = true;
                }
            }

            // Group 3: Check qty 
            if (!isNaN(manualQty) && !isNaN(systemQty)) {
                if (manualQty !== systemQty) {
                    isMismatch = true;
                }
            }

            if (isMismatch && ((!isNaN(manualItemCount) && !isNaN(systemItemCount)) || (!isNaN(manualAmt) && !isNaN(systemAmt)) || (!isNaN(manualQty) && !isNaN(systemQty)))) {
                console.log("Mismatch: YES");
                challanMasterData.bill_match_yn = "MisMatch"
            } else if (!isMismatch && ((!isNaN(manualItemCount) && !isNaN(systemItemCount)) || (!isNaN(manualAmt) && !isNaN(systemAmt)) || (!isNaN(manualQty) && !isNaN(systemQty)))) {
                console.log("Mismatch: NO or Insufficient data to compare");
                challanMasterData.bill_match_yn = "Match"
            } else {
                challanMasterData.bill_match_yn = "Pending"

            }


            // challanMasterData.bill_match_yn = billMatch;


            // system calculated 
            // bill_match_yn
            // item_count : totalItemCount
            // tot_qty : totalItemQty
            // final_amount : finalAmount


            setChallanMasterData(prevState => ({
                ...prevState,
                apx_weight: totalItemWt,
                gross_amt: totalGrossAmount,
                misc_exp_total: totalChallanMiscRate,
                tot_qty: totalItemQty,
                cart_amt_final: cartAmtTransporter,
                gross_amt_before_tax: totalGrossAmount + cartAmtTransporter,

                tax_amt: taxAmount,
                amount_with_gst: amountWithGst,

                cart_tcs_value: tcsAmount,
                amount_with_tcs: amountWithTcs,
                tds_amount: tdsAmount,

                final_amount: finalAmount,


                // round off value  
                roundoff_amount: roundOffValue,
                // finalAmount: finalAmount,

                // // cartage transport key name
                cart_amt_with_gst_transporter: cartAmountWithGst + cartAmtTransporter,
                cart_tax_amount_transporter: cartAmountWithGst,
            }));
        }


    }, [singleItemSelectArray,
        challanMasterData.cart_per_tax_transporter, challanMasterData.cart_amt_transporter,
        challanMasterData.cart_tcs_yn, challanMasterData.cart_tcs_percentage, challanMiscTransTable,
        challanMasterData.cart_transporter_cartage, challanMasterData.roundoff_yn,


        challanMasterData.item_count_manual, challanMasterData.total_qty_manual,
        challanMasterData.total_amt_manual,

        challanMasterData.tds_option
    ])


    //  this fucntion used for open the  insert/create new item extra detailte model

    const [showSingleItemExtraDetailModel, setShowSingleItemExtraDetailModel] = useState(false)
    let initialStockDetail = {
        item_name: "",
        item_code: null,
        item_stock_date: null,
        item_stock_location: "",
        item_stock_qty: null,
        item_stock_rate: null,
        item_stock_value: null,

        item_batch_no: "",
        item_style: "",
        item_brand: "",
        item_color: "",
        item_agent: "",
        item_dealer: "",
    }
    const [stockDetailTable, setStockDetailTable] = useState([])
    const [stockDetailArray, setStockDetailArray] = useState([])
    const [stockDetail, setStockDetail] = useState(initialStockDetail)
    const [removestockDetailDeleteArray, setRemovestockDetailDeleteArray] = useState([])

    const openSingleItemExtraDetailModel = (itemId, itemName) => {
        const filteredData = stockDetailTable.filter(item => item.item_code == parseInt(itemId));
        setStockDetailArray(previous => [
            ...filteredData
        ]);

        setStockDetail((prevData) => ({
            ...prevData,
            item_code: itemId,
            item_name: itemName,
            pname: partyMasterName,
            pcode: partyMasterId
        }));

        setShowSingleItemExtraDetailModel(true)
    }

    const closeSingleItemExtraDetailModel = () => {
        setShowSingleItemExtraDetailModel(false);
        setStockDetail(initialStockDetail);

    };

    // const confirmSingleItemExtraDetailModel = () => {
    //     setShowSingleItemExtraDetailModel(false);
    //     setStockDetail(initialStockDetail);
    // }


    const onChangeStockDetailHandle = (e) => {
        const { name, value } = e.target;

        setStockDetail((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }

    useEffect(() => {

        let stockQty = parseFloat(stockDetail.item_stock_qty || 0)
        let stockRate = parseFloat(stockDetail.item_stock_rate || 0)

        setStockDetail((prevData) => ({
            ...prevData,
            item_stock_value: stockQty * stockRate
        }));
    }, [stockDetail.item_stock_qty, stockDetail.item_stock_rate])


    const AddStockDetail = () => {

        // Check if itemData is not empty
        if (Object.keys(stockDetail).length !== 0) {

            setStockDetailArray((prevItems) => [...prevItems, { ...stockDetail, data_mode: "old" }]);
            setStockDetailTable((prevItems) => [...prevItems, { ...stockDetail, data_mode: "old" }]);
            setStockDetail(initialStockDetail);
        }
    };


    const RemoveStockDetail = (indexToRemove) => {
        setStockDetailTable((prevState) => {
            const updatedStockDetailArray = prevState.filter((item, index) => index !== indexToRemove);
            // const removedItem = prevState.find((item, index) => index === indexToRemove);

            // if (removedItem) {
            //     setRemovestockDetailDeleteArray((prevDeleteArray) => [...prevDeleteArray, removedItem]);
            // }

            return updatedStockDetailArray;
        });

        setStockDetailArray((prevState) => {
            const updatedStockDetailArray = prevState.filter((item, index) => index !== indexToRemove);
            const removedItem = prevState.find((item, index) => index === indexToRemove);

            if (removedItem) {
                setRemovestockDetailDeleteArray((prevDeleteArray) => [...prevDeleteArray, removedItem]);
            }

            return updatedStockDetailArray;
        });
    }

    // this fucntion is used for get the state list 
    const getLocation = async () => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`api/LocationMaster/allLocation`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setLocationTable(response.locationMasterDetailData)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }

    useEffect(() => {
        getLocation()
    }, [])

    const getItemDataByItemId = async (itemId) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/ItemMaster/itemDetailById?itemId=${itemId}`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                // setItemDetail(response?.itemMasterDetailByID)
                // const findItemData = itemTable.find((data) => data.id == response.issueReceiptMasterDetailByID.item_code);

                const transformedArray = response?.itemMasterDetailByID.itemTransMixDetail.map(({ item_qty, item_rate, ...rest }) => ({
                    ...rest,
                    recv_qty: item_qty,
                    rent_rate: item_rate
                }));
                // setSingleItemSelectArray(transformedArray);
                setItemTable(transformedArray)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }


    // this function is used for  create / insert  single item model 

    const [showSingleItemModel, setShowSingleItemModel] = useState(false)
    const [saleMethod, setSaleMethod] = useState("")

    const openSingleItemModel = () => {
        setShowSingleItemModel(true);
    }

    const closeSingleItemModel = () => {
        setShowSingleItemModel(false);
    };
    const onInsertSingleItemModel = () => {
        setShowSingleItemModel(false);
        if (saleMethod == "group_type") {
            getItemDataByItemId(challanMasterData.item_code)
        } else {
            getItemData()
        }
    }

    // const goTODeleteModel = (id) => {
    //     navigate("/commonDelete", { state: { itemId: id, flag: "issue", } })
    // }

    const goTODeleteModel = (id) => {
        const currentUrl = `${window.location.origin}`;
        const url = `${currentUrl}/commonDelete?itemId=${id}&flag=issue_challan`;
        // navigate("/challan_issue")
        window.open(url, '_blank');
        setTimeout(() => {
            window.close();
        }, 1000);
        // setTimeout(()=>{

        // },[2])
    };


    // get the  helper mastr data 

    const [helperMasterSingleItem, setHelperMasterSingleItem] = useState([])
    const [helperMasterSingleItemWarrantyPeriod, setHelperMasterSingleItemWarrantyPeriod] = useState([])

    const getHelperMaster = async (formName) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                if (formName == "issue_single_item_detail") {
                    setHelperMasterSingleItem(response.helperMasterData)
                }

                if (formName == "issue_challan_warranty_period") {
                    setHelperMasterSingleItemWarrantyPeriod(response.helperMasterData)
                }
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }



    useEffect(() => {
        getHelperMaster("issue_single_item_detail")
        getHelperMaster("issue_challan_warranty_period")
    }, [])


    const [printMode, setPrintMode] = useState(false)
    const [systemInvoice, setSystemInvoice] = useState("")


    const gotoPrintMode = async () => {
        // setPrintMode(true)

        let BranchData = branchMaster.find((data) => data.id == challanMasterData.branch_master_id)


        let partyPrimaryAddress = partyMasterMultipleAddress.find(
            (data) => data.party_address_description === "primary" //"Bill To/Primary"
        )

        if (!challanMasterData.addr_type) {

            // First, update challanMasterData with address fields
            challanMasterData.add1 = partyPrimaryAddress?.party_address_1;
            challanMasterData.add2 = partyPrimaryAddress?.party_address_2;
            challanMasterData.add3_location = partyPrimaryAddress?.party_address_location;
            challanMasterData.add4_city = partyPrimaryAddress?.party_city;
            challanMasterData.add5_state = partyPrimaryAddress?.party_state;
            challanMasterData.add6_pincode = partyPrimaryAddress?.party_pincode?.toString();
            challanMasterData.addr_type = partyPrimaryAddress?.party_address_description;
            challanMasterData.addr_gst_type = partyPrimaryAddress?.party_gst_type;
            challanMasterData.gstno = partyPrimaryAddress?.party_gst_address_no;
            challanMasterData.state_code = partyPrimaryAddress?.party_gst_code;
            challanMasterData.gst_type = partyPrimaryAddress?.party_gst_type;
        }

        const data = {
            // old 
            challanMasterData,
            System_Records_data,
            stockDetailTable,
            ItemTable: aggrementTable.length !== 0 ? aggrementTable : singleItemSelectArray,
            BranchData: BranchData,
            partyBillAddress: partyPrimaryAddress,


            // new 
            // showItemWiseBill: aggrementTable.length !== 0 ? aggrementTable : singleItemSelectArray,
            // billDetail: challanMasterData,
            // System_Records_data,
            // BranchData: BranchData,
        };

        //console.log(BranchData, "BranchData")

        const currentUrl = `${window.location.origin}`;
        sessionStorage.setItem('printData', JSON.stringify(data));

        //         if (!BranchData?.branch_invoice_temp || !String(BranchData.branch_invoice_temp).trim()) {
        //     toast.error("Invoice template not found for this branch. Please contact administrator.");
        //     return;
        // }

        // let url = await getInvoiceUrl(BranchData?.branch_invoice_temp, currentUrl);

        let systemInvoice = "invoice3"
        let url = `${currentUrl}/invoice`;

        if (systemInvoice == "invoice") {
            url = `${currentUrl}/invoice`;
        } else if (systemInvoice == "invoice2") {
            url = `${currentUrl}/invoice_fm2`;
        } else if (systemInvoice == "invoice3") {
            url = `${currentUrl}/invoice_fm3`;
        } else if (systemInvoice == "invoice4") {
            url = `${currentUrl}/invoice_fm4`;
        } else if (systemInvoice == "invoice5") {
            url = `${currentUrl}/invoice_fm5`;
        } else if (systemInvoice == "invoice5_landscape") {
            url = `${currentUrl}/invoice_fm5_landscape`;
        } else if (systemInvoice == "invoice6") {
            url = `${currentUrl}/invoice_fm6`;
        } else if (systemInvoice == "invoice7") {
            url = `${currentUrl}/invoice_fm7`;
        } else if (systemInvoice == "invoice8_optical") {
            url = `${currentUrl}/invoice_fm8_optical`;
        }
        window.open(url, '_blank');
    }

    const formatBillingData = (data) => {
        const challan = data?.challanMasterData;
        const items = data?.ItemTable || [];
        const system = data?.System_Records_data?.[0];
        const branch = data?.BranchData;

        // 👉 Format Date
        const formatDate = (dateStr) => {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            }).toUpperCase();
        };


        // 👉 Items Mapping
        const mappedItems = items
            .filter(item => item?.item_name) // remove empty row
            .map((item, index) => ({
                srNo: index + 1,
                brand: item?.brand || '',
                itemCode: item?.item_short_name || '',
                itemName: item?.item_name || '',
                quantity: Number(item?.issue_qty || 0),
                uom: item?.sale_unit_name || 'NOS',
                rate: Number(item?.item_rate_after_gst_one_pc || 0),
                total: Number(item?.item_gross_amount_one_pc || 0),
                gst: Number(item?.item_gst_amt_one_pc || 0),
                grandTotal: Number(item?.total_amount_with_gst_one_pc || 0),
            }));

        // 👉 Totals
        const totalQuantity = mappedItems.reduce((sum, i) => sum + i.quantity, 0);
        const totalAmount = mappedItems.reduce((sum, i) => sum + i.total, 0);
        const totalGst = mappedItems.reduce((sum, i) => sum + i.gst, 0);
        const grandTotal = mappedItems.reduce((sum, i) => sum + i.grandTotal, 0);

        const { customer, supplier } = getPartyDetails(
            challan?.irflag,
            challan,
            system
        );

        return {
            poNumber: challan?.manual_billno || challan?.billno_automatic || '',
            date: formatDate(challan?.bill_date),
            // 👉 Customer (Party)
            customer,
            // 👉 Supplier (Company)
            supplier,
            items: mappedItems,
            totalQuantity,
            totalAmount,
            totalGst,
            grandTotal,
            deliveryDate: formatDate(challan?.delivery_date),
            remarks: challan?.remark_note || 'N/A',

            terms: `Declaration :
This document confirms the purchase of goods as per the terms
agreed between the supplier and the purchaser.`
        };
    };

    const getPartyDetails = (irFlag, challan, system) => {
        const isPurchase = ["PC", "PO"].includes(irFlag);

        if (isPurchase) {
            return {
                // 👉 In Purchase → YOU are Customer
                customer: {
                    name: system?.company_name || '',
                    address: system?.company_address || '',
                    contactPerson: '',
                    mobile: system?.company_phone || '',
                },
                supplier: {
                    name: challan?.pname || '',
                    address: '',
                    contactPerson: challan?.contact_prs || '',
                    mobile: challan?.pmobile_number || '',
                }
            };
        } else {
            return {
                // 👉 In Sale/Issue → YOU are Supplier
                supplier: {
                    name: system?.company_name || '',
                    address: system?.company_address || '',
                    contactPerson: '',
                    mobile: system?.company_phone || '',
                },
                customer: {
                    name: challan?.pname || '',
                    address: '',
                    contactPerson: challan?.contact_prs || '',
                    mobile: challan?.pmobile_number || '',
                }
            };
        }
    };

    const newPrintMode = () => {
        let BranchData = branchMaster.find((data) => data.id == challanMasterData.branch_master_id)


        let partyPrimaryAddress = partyMasterMultipleAddress.find(
            (data) => data.party_address_description === "primary" //"Bill To/Primary"
        )

        if (!challanMasterData.addr_type) {

            // First, update challanMasterData with address fields
            challanMasterData.add1 = partyPrimaryAddress?.party_address_1;
            challanMasterData.add2 = partyPrimaryAddress?.party_address_2;
            challanMasterData.add3_location = partyPrimaryAddress?.party_address_location;
            challanMasterData.add4_city = partyPrimaryAddress?.party_city;
            challanMasterData.add5_state = partyPrimaryAddress?.party_state;
            challanMasterData.add6_pincode = partyPrimaryAddress?.party_pincode?.toString();
            challanMasterData.addr_type = partyPrimaryAddress?.party_address_description;
            challanMasterData.addr_gst_type = partyPrimaryAddress?.party_gst_type;
            challanMasterData.gstno = partyPrimaryAddress?.party_gst_address_no;
            challanMasterData.state_code = partyPrimaryAddress?.party_gst_code;
            challanMasterData.gst_type = partyPrimaryAddress?.party_gst_type;
        }

        const data = {
            // old 
            challanMasterData,
            System_Records_data,
            stockDetailTable,
            ItemTable: aggrementTable.length !== 0 ? aggrementTable : singleItemSelectArray,
            BranchData: BranchData,
            partyBillAddress: partyPrimaryAddress,


            // new 
            // showItemWiseBill: aggrementTable.length !== 0 ? aggrementTable : singleItemSelectArray,
            // billDetail: challanMasterData,
            // System_Records_data,
            // BranchData: BranchData,
        };

        const billData = formatBillingData(data);

        //navigate("/PrintBill", { state: { billData } });

        localStorage.setItem("printData", JSON.stringify(billData));

        window.open("/PrintBill", "_blank");
    }


    const gotoBackMode = () => {
        setPrintMode(false)
        window.location.reload();
    }

    const [viewWarrantyMode, setViewWarrantyMode] = useState(false)

    const [venderMaster, setVenderMasterTable] = useState([]);
    const [branchMaster, setBranchMasterTable] = useState([]);


    const OpenWarrantyModel = (itemId, itemName) => {


        console.log(itemId, itemName, " item name and item id ")

        const filteredData = warrantyArraySlots.filter(item => item.item_code == itemId);
        setWarrantySlots(previous => [
            ...filteredData
        ]);

        const findItemData = itemTable.find((data) => data.id === itemId);

        console.log(findItemData, "@@@@@@@@@@@@@@@@")

        setWarrantySlotDetail(prevState => ({
            ...prevState,
            warranty_period: findItemData.warranty_period != "" ? findItemData.warranty_period : singleItemSelect.item_warranty_period,
            warranty_visit_slot: singleItemSelect.item_warranty_visit_count,
            item_code: itemId,
            item_name: itemName,
        }));
        setOpenWarrantyVisit(true)
        setViewWarrantyMode(false)

    }



    const viewWarrantyModel = (itemId, itemName, index) => {

        const filteredData = warrantyArraySlots.filter(item => item.item_code == itemId);
        setWarrantySlots(previous => [
            ...filteredData
        ]);

        const findSingleItemArrayData = singleItemSelectArray[index];
        setWarrantySlotDetail(prevState => ({
            ...prevState,
            warranty_period: findSingleItemArrayData?.item_warranty_period ? findSingleItemArrayData.item_warranty_period : "",
            warranty_visit_slot: findSingleItemArrayData.item_warranty_visit_count ? findSingleItemArrayData.item_warranty_visit_count : "",
            item_code: itemId,
            item_name: itemName,
            warranty_visit_charge: filteredData[0]?.warranty_visit_charge
        }));
        setOpenWarrantyVisit(true)
        setViewWarrantyMode(true)
    }

    const ClosedWarrantyModel = () => {
        setOpenWarrantyVisit(false)
        setWarrantySlotDetail({})
        setViewWarrantyMode(false)

        // setWarrantySlots([])
    }

    const handleChallanWarrantyChange = (e) => {
        const { name, value } = e.target;

        setWarrantySlotDetail(prevState => ({
            ...prevState,
            [name]: value
        }));

    }

    const calculateWarrantySlotDates = () => {
        const startDate = moment();

        let totalWarrantyPeriod = warrantySlotDetail.warranty_period;       /// warranty period
        let totalSlots = warrantySlotDetail.warranty_visit_slot;   /// warranty visit slot
        let charge = warrantySlotDetail.warranty_visit_charge;    /// warranty visit chargable
        let item_code = warrantySlotDetail.item_code;
        let item_name = warrantySlotDetail.item_name


        const month = totalWarrantyPeriod.match(/(\d+)\s*(Months?)/i);
        const year = totalWarrantyPeriod.match(/(\d+)\s*(Years?)/i);


        let slotIntervalInMonths
        // Check for months
        if (month) {
            let totalMonths = parseInt(month[1], 10); // Extract numeric value for months
            slotIntervalInMonths = Math.floor(totalMonths / totalSlots);
        }

        // Check for years
        if (year) {
            let totalYears = parseInt(year[1], 10); // Extract numeric value for years
            slotIntervalInMonths = (totalYears * 12) / totalSlots;
        }

        let slots = [];
        for (let i = 1; i <= totalSlots; i++) {
            const slotDate = startDate.clone().add(slotIntervalInMonths * i, 'months');
            slots.push({
                warranty_visit_date: slotDate.format('YYYY-MM-DD'),
                warranty_visit_charge: charge,
                warranty_visit_slot: i.toString(),
                warranty_period: totalWarrantyPeriod,
                item_name: item_name,
                item_code: item_code,
                warranty_flag: "new_warranty"
                // warranty_serial_no : 
            });
        }

        setWarrantySlots(slots);


        // setWarrantyArraySlots((prevItems) => {
        //     const newSlots = slots.filter(slot => !prevItems.includes(slot)); // Filter out duplicates
        //     return [...prevItems, ...newSlots]; // Update state with unique items only
        // });
        setWarrantyArraySlots((prevItems) => {
            const itemIdToCheck = warrantySlotDetail.item_code
            const filteredItems = prevItems.filter(item => item.item_code !== itemIdToCheck);
            const newSlots = slots.filter(slot => slot.item_code === itemIdToCheck && !filteredItems.includes(slot));
            return [...filteredItems, ...newSlots];
        });

    };


    const getVendorName = async (page = 1, limit = 10, search = "") => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {


                if (response.venderMasterData.length == 1 && response.venderMasterData) {

                    setVenderMasterTable(response.venderMasterData)
                    setChallanMasterData((prevDetails) => ({
                        ...prevDetails,
                        vender_master_id: response.venderMasterData[0].id,
                    }));

                } else {
                    setVenderMasterTable(response.venderMasterData)
                }
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
        finally {
            setPageLoading(prev => ({ ...prev, vender: false }));
        }
    };

    const getBranchMasterData = async (page = 1, limit = 10, search = "") => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const filterName = challanMasterData.vender_master_id ? challanMasterData.vender_master_id : null;

            let queryString = `pageNo=${page}&limit=100000&searchKey=${search}`;
            if (filterName) {
                queryString += `&filterName=${filterName}`;
            }


            const response = await apiService.get(`/api/BranchMaster/all?${queryString}`, config);
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {

                if (response.branchMasterData.length == 1 && response.branchMasterData) {

                    setBranchMasterTable(response.branchMasterData)
                    setChallanMasterData((prevDetails) => ({
                        ...prevDetails,
                        branch_master_id: response.branchMasterData[0].id,
                    }));

                } else {
                    setBranchMasterTable(response.branchMasterData)

                    // if (!location?.state?.challanId) {
                    //     setChallanMasterData((prevDetails) => ({
                    //         ...prevDetails,
                    //         branch_master_id: null
                    //     }));
                    // }
                }

            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
        finally {
            setPageLoading(prev => ({ ...prev, branch: false }));
        }
    };


    const handleChallanSingleItem = (event, value) => {

        if (value === null || value === undefined) {

            setChallanMasterData((prevState) => ({
                ...prevState,
                item_name: "",
                item_code: ""
            }));
            return;
        }

        const findItemData = itemTable.find((data) => data.id === value.id);

        if (findItemData) {
            setChallanMasterData((prevState) => ({
                ...prevState,
                item_name: findItemData?.item_name || "",
                item_code: String(findItemData.id)
            }));

            // setItemMixedDetail(findItemData.itemTransMixDetail)
            // setSingleItemSelectArray(findItemData.itemTransMixDetail)
        }
    }
    const handleVenderSelect = async (event, value) => {

        if (value === null || value === undefined) {

            setChallanMasterData((prevData) => ({
                ...prevData,
                vender_master_id: null
            }));
            return;

        } else {
            await setChallanMasterData((prevData) => ({
                ...prevData,
                vender_master_id: value.id
            }));
        }
    };

    const handleBranchSelect = async (event, value) => {

        if (value === null || value === undefined) {

            setChallanMasterData((prevData) => ({
                ...prevData,
                branch_master_id: null
            }));
            return;

        } else {
            await setChallanMasterData((prevData) => ({
                ...prevData,
                branch_master_id: value.id
            }));
        }
    };

    useEffect(() => {
        getVendorName()
        getBranchMasterData()
    }, [challanMasterData.vender_master_id])

    const [showErrorModal, setShowErrorModal] = useState(false)
    const [pageloading, setPageLoading] = useState({
        vender: true,
        branch: true,
        // party: true,
    });

    useEffect(() => {

        const allApisLoaded = Object.values(pageloading).every(status => status === false);

        if (!allApisLoaded) return;

        const newErrors = {};

        if (!venderMaster || venderMaster.length === 0) {
            newErrors.vender_master_id = 'Vender is required.';
        }

        if (!branchMaster || branchMaster.length === 0) {
            newErrors.branch_master_id = 'Branch is required.';
        }

        // if (!partyTable || partyTable.length === 0) {
        //     newErrors.name = 'Housekeeper Assigned is required.';
        // }

        if (Object.keys(newErrors).length != 0) {
            setErrorMessage(newErrors);
            setShowErrorModal(true);
        } else {
            setErrorMessage({});
            setShowErrorModal(false);
        }
    }, [branchMaster, venderMaster, pageloading, system_Records_Issue_Challan_data]);



    // =============================== misc model code ==========================

    const [miscShowModal, setMiscShowModal] = useState(false);
    // const [fromName, setFromName] = useState("")

    let openMiscModal = (flagname) => {
        // setFromName(flagname);
        setMiscShowModal(true);
    }
    const closedMiscModal = () => {
        setMiscShowModal(false);
    }
    const onInsertMiscPartyModel = () => {
        setMiscShowModal(false);
        // getItemData()
        getPartyDataByGroupName(['MISC. ACCOUNTS For Challan'], "misc");
    }


    // ============= Remark Document  detail  ====================

    const [remarkPageArrayList, setremarkPageArrayList] = useState([])
    const [deleteRemarkPageArrayList, setDeleteRemarkPageArrayList] = useState([])
    const [helperMasterDocumentTypeTable, setHelperMasterDocumentTypeTable] = useState([])
    const [showHelperModal, setHelperModal] = useState(false);
    const [fromName, setFromName] = useState("")
    const [helperMasterWorkBussinessTable, setHelperMasterWorkBussinessTable] = useState([]);

    // Generic function to fetch helper master data
    const getHelperMasterData = async (formName, setStateCallback) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config);

            if (response.response?.data?.errors) {
                toast.success(response.response?.data?.errors);
                return;
            }

            if (response.status === true) {
                setStateCallback(response.helperMasterData);
            } else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error);
            toast.error(`Something went wrong!!`);
        }
    };

    useEffect(() => {
        getHelperMasterData("remark_detail_document_issue", setHelperMasterDocumentTypeTable);
        getHelperMasterData("working_bussinesss_mode", setHelperMasterWorkBussinessTable);

    }, [])


    const fetchHelperData = () => {
        if (fromName === "remark_detail_document_issue") {
            getHelperMasterData("remark_detail_document_issue", setHelperMasterDocumentTypeTable);
        }

    }

    const openHelperModal = (flagname) => {
        setFromName(flagname);
        setHelperModal(true);
    }

    const closedHelperModal = () => {
        setHelperModal(false);
    }





    //  =========================  open status change model  ========================

    const [statusDropdown, setStatusDropdown] = useState([
        { field_name: "Pending", field_data: "Pending" },
        { field_name: "Accepted", field_data: "Accepted" },
        { field_name: "Working in Process", field_data: "Working in Process" },
        { field_name: "Completed", field_data: "Completed" },
        { field_name: "Cancel", field_data: "Cancel" },
    ]);
    const [chStatusList, setChStatusList] = useState([]);
    const [errorPoStatusMessage, setErrorPoStatusMessage] = useState({})
    const [showStatusModel, setShowStatusModel] = useState(false)
    const [poStatusDetail, setPoStatusDetail] = useState({
        status: "",
        remark: "",
        exception_date: null
    })

    const handleStatusDetail = (e) => {
        const { name, type, value } = e.target
        setPoStatusDetail((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    const openStatusModel = () => {
        setShowStatusModel(true);
        setPoStatusDetail((preState) => ({
            ...preState,
            status: challanMasterData.ch_status,
        }))
    }

    const closedStatusModel = () => {
        setShowStatusModel(false);
        setPoStatusDetail({
            status: "",
            remark: "",
            exception_date: null
        })
    }

    const validatePoStatusForm = () => {
        let error = {}
        if (!poStatusDetail.status) {
            error.status = "Please select a status.";
        }

        // if (!poStatusDetail.remark.trim()) {
        //     error.remark = "Please enter a remark.";
        // }

        if (Object.keys(error).length > 0) {
            setErrorPoStatusMessage(error)
            return true;
        } else {
            setErrorPoStatusMessage({})
            return false;
        }
    }

    const updateStatusDetail = async () => {

        let validation = validatePoStatusForm()
        if (validation) {
            return
        }

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            let params = {
                ...challanMasterData,
                ch_status: poStatusDetail.status,
                po_status_remark: poStatusDetail.remark,
                po_exception_date: poStatusDetail.exception_date
            }

            const response = await apiService.put(`/api/IssueReceipt/updateStatus?challanId=${challanMasterData.id}`, params, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                console.log(response, 'response data')
                setShowStatusModel(false);
                toast.success("Status updated successfully");
                setPoStatusDetail({
                    status: "",
                    remark: ""
                })

                getChallanByChallanId(location.state.challanId)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }


    const formatNumber = (number) => {
        return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(number);
    };



    useEffect(() => {
        if (challanMasterData.challan_by == "RECEIVE_CHALLAN") {

            document.querySelectorAll("input").forEach(input => {
                input.disabled = true;
            });

            document.querySelectorAll("input, select, textarea").forEach(element => {
                element.disabled = true;
            });

        }
    }, [])

    if (Object.values(pageloading).some(status => status == true)) {
        return <SpinnerLoader />
    }


    return (
        <>
            {
                false ?
                    <>
                        {/* < PDFGeneratorButton
                            challanMasterData={challanMasterData}
                            System_Records_data={System_Records_data}
                            stockDetailTable={stockDetailTable}
                            ItemTable={aggrementTable.length != 0 ? aggrementTable : singleItemSelectArray}
                            onHandleBackInvoice={gotoBackMode} /> */}

                        <CreatePdf_Formate6
                            challanMasterData={challanMasterData}
                            System_Records_data={System_Records_data}
                            stockDetailTable={stockDetailTable}
                            ItemTable={aggrementTable.length != 0 ? aggrementTable : singleItemSelectArray}
                            onHandleBackInvoice={gotoBackMode}
                        />
                    </>
                    :
                    <>

                                {/* Action Buttons */}
                                <Row className="bg-white pd-20 card-box mb-5 toolbar-row sticky-top" >
                                    <Col className="d-flex justify-content-end align-items-center toolbar-buttons">

                                        {editMode && (
                                            <>
                                               
                                                <div className="dropdown">
                                                    <Button
                                                        className="btn btn-primary btn-sm dropdown-toggle mr-2"
                                                        color='primary'
                                                        data-toggle="dropdown"
                                                        aria-expanded="true"
                                                    >
                                                        <i className="bi bi-three-dots-vertical"></i> More Options
                                                    </Button>
                                                    <div
                                                        className="dropdown-menu dropdown-menu-right dropdown-menu-icon-list shadow-lg border"
                                                        x-placement="bottom-end">


                                                        {printMode && <a className="dropdown-item border-bottom" href='#'
                                                            onClick={newPrintMode}
                                                        >
                                                            <i className="bi bi-printer-fill text-info me-2"></i>
                                                            Print
                                                        </a>}

                                                        <a className="dropdown-item border-bottom" href='#'
                                                            onClick={() => goTODeleteModel(challanMasterData.id)}
                                                            disabled={challanMasterData.challan_by === "RECEIVE_CHALLAN"}
                                                        >
                                                            <i className="bi bi-trash-fill text-danger me-2"></i> Delete

                                                        </a>
                                                    </div>
                                                </div>

                                                <Button
                                                    color="success"
                                                    className="mr-2 btn-sm"
                                                    onClick={UpdateChallanMasterData}
                                                    disabled={challanMasterData.challan_by === "RECEIVE_CHALLAN"}
                                                >
                                                    <i className="bi bi-save mr-2"></i>
                                                    {isLoading ? <Loader /> : "Save"}
                                                </Button>
                                            </>
                                        )}

                                        {!challanId && (
                                            <Button color="warning" onClick={onHandleBackParty} className="mr-0 btn-sm">
                                                <i className="bi bi-arrow-left mr-2"></i>Back
                                            </Button>
                                        )}

                                    </Col>
                                </Row>

                                <Card className='bg-white pd-10 card-box mb-30'>
                                    <CardTitle tag="h6" className="border-bottom p-3 mb-0">

                                        <Row className="align-items-center">

                                            <Col sm={12} className="d-flex flex-row flex-md-row align-items-start align-items-md-center justify-content-between mb-2 mb-md-0">
                                                {/* Left side: Title and icon */}
                                                <div className="d-flex align-items-center">
                                                    <i className="bi bi-bell mr-2"></i>
                                                    {editMode ? props.title : props.title}
                                                </div>

                                                {editMode
                                                    && <Button
                                                        style={{
                                                            marginLeft: "5px",
                                                            padding: "2px 6px",
                                                            fontSize: "12px",
                                                            borderRadius: "4px",
                                                            cursor: "pointer",
                                                            backgroundColor: "green",
                                                            border: 0
                                                        }}
                                                        className='ml-auto'
                                                        onClick={() => openStatusModel()}
                                                    >
                                                        <i className="bi bi-plus-circle" style={{ fontSize: "14px", marginRight: "5px" }}></i>
                                                        Change  Status
                                                    </Button>}

                                                {/* Right side: Status badge */}
                                                {system_Records_Issue_Challan_data.ch_status_yn?.toLowerCase() == "yes" && (
                                                    <div className="d-flex justify-content-end">
                                                        <span className="badge bg-success p-2 ml-2">
                                                            {challanMasterData.ch_status}
                                                        </span>
                                                    </div>
                                                )}

                                            </Col>
                                        </Row>
                                    </CardTitle>


                                    <CardBody>

                                        <Row>

                                            {(venderMaster.length === 0 || venderMaster.length > 1) && <Col xl={12}>
                                                <FormGroup>
                                                    <Label for="vender_master_id">Vender Name</Label>

                                                    <Autocomplete
                                                        size="small"
                                                        // sx={{ width: 300 }}
                                                        autoHighlight
                                                        id="vender_master_id"
                                                        name="vender_master_id"
                                                        options={venderMaster}
                                                        getOptionLabel={(option) => option.vender_name || ""}
                                                        renderInput={(params) => <TextField {...params}
                                                            // label="Select"
                                                            placeholder="Select Vender"

                                                        />}
                                                        renderOption={(props, option, state) => (
                                                            <li {...props} key={state.index}>
                                                                {option.vender_name}
                                                            </li>
                                                        )}
                                                        renderGroup={(params) => params}
                                                        value={venderMaster.find(option => option.id === challanMasterData.vender_master_id) || null}
                                                        onChange={handleVenderSelect}
                                                    // readOnly={editMode}
                                                    />
                                                    {errorMessage.vender_master_id && <div className="text-danger">{errorMessage.vender_master_id}</div>}

                                                </FormGroup>
                                            </Col>}

                                            {(branchMaster.length === 0 || branchMaster.length > 1) && <Col xl={12}>
                                                <FormGroup>
                                                    <Label for="branch_master_id">Branch Name</Label>

                                                    <Autocomplete
                                                        size="small"
                                                        // sx={{ width: 300 }}
                                                        autoHighlight
                                                        id="branch_master_id"
                                                        name="branch_master_id"
                                                        options={branchMaster}
                                                        getOptionLabel={(option) => option.branch_name || ""}
                                                        renderInput={(params) => <TextField {...params}
                                                            // label="Select"
                                                            placeholder="Select Branch"

                                                        />}
                                                        renderOption={(props, option, state) => (
                                                            <li {...props} key={state.index}>
                                                                {option.branch_name}
                                                            </li>
                                                        )}
                                                        renderGroup={(params) => params}
                                                        value={branchMaster.find(option => option.id === challanMasterData.branch_master_id) || null}
                                                        onChange={handleBranchSelect}
                                                    />
                                                    {errorMessage.branch_master_id && <div className="text-danger">{errorMessage.branch_master_id}</div>}

                                                </FormGroup>
                                            </Col>}

                                            <Col sm={3}>
                                                <FormGroup>

                                                    <Label for="manual_billno">Bill No</Label>
                                                    <Input type="text" name="manual_billno" id="manual_billno" value={challanMasterData.manual_billno || ''} onChange={handleChange} />

                                                    {errorMessage.manual_billno && (
                                                        <FormText color='danger'>
                                                            {errorMessage.manual_billno}
                                                        </FormText>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col sm={3}>
                                                <FormGroup>
                                                    <Label for="bill_date">Bill Date</Label>
                                                    <Input 
                                                    type="date" 
                                                    name="bill_date" 
                                                    id="bill_date"
                                                    min={sessionData.session_start_date}
                                                    max={sessionData.session_end_date}
                                                    value={challanMasterData?.bill_date?.split('T')[0]}
                                                    onChange={handleChange} 
                                                    />

                                                    {errorMessage.bill_date && (
                                                        <FormText color='danger'>
                                                            {errorMessage.bill_date}
                                                        </FormText>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            {system_Records_Issue_Challan_data.ch_man_item_ct_yn == "yes" &&
                                             <Col sm={2}>
                                                <FormGroup>
                                                    <Label for="item_count_manual"> Item Count </Label>
                                                    <Input type="text" name="item_count_manual" id="item_count_manual"
                                                        value={challanMasterData?.item_count_manual}
                                                        onChange={handleChange} />
                                                    {errorMessage.item_count_manual && (
                                                        <FormText color='danger'>
                                                            {errorMessage.item_count_manual}
                                                        </FormText>
                                                    )}
                                                </FormGroup>
                                            </Col>}


                                            {system_Records_Issue_Challan_data.ch_man_qty_yn == "yes" && <Col sm={2}>
                                                <FormGroup>
                                                    <Label for="total_qty_manual">Total Qty </Label>
                                                    <Input type="text" name="total_qty_manual" id="total_qty_manual"
                                                        value={challanMasterData?.total_qty_manual}
                                                        onChange={handleChange} />
                                                    {errorMessage.total_qty_manual && (
                                                        <FormText color='danger'>
                                                            {errorMessage.total_qty_manual}
                                                        </FormText>
                                                    )}
                                                </FormGroup>
                                            </Col>}


                                            {system_Records_Issue_Challan_data.ch_man_amt_yn == "yes" && <Col sm={2}>
                                                <FormGroup>
                                                    <Label for="total_amt_manual">Total Amt. </Label>
                                                    <Input type="text" name="total_amt_manual" id="total_amt_manual"
                                                        value={challanMasterData?.total_amt_manual}
                                                        onChange={handleChange} />
                                                    {errorMessage.total_amt_manual && (
                                                        <FormText color='danger'>
                                                            {errorMessage.total_amt_manual}
                                                        </FormText>
                                                    )}
                                                </FormGroup>
                                            </Col>}
                                            

                                            {/* {system_Records_Issue_Challan_data.ch_bill_mat_yn == "yes" && <Col sm={2}>
                                                <FormGroup>
                                                    <Label for="bill_match_yn"> Bill Match. </Label>
                                                    <Input  type="select"  className="custom-select" name="bill_match_yn" id="bill_match_yn"
                                                        value={challanMasterData?.bill_match_yn}
                                                        onChange={handleChange} >
                                                        <option value="MisMatch">MisMatch</option>
                                                        <option value="Match">Match</option>
                                                        <option value="Pending">Pending</option>
                                                    </Input>
                                                    {errorMessage.total_amt_manual && (
                                                        <FormText color='danger'>
                                                            {errorMessage.total_amt_manual}
                                                        </FormText>
                                                    )}
                                                </FormGroup>
                                            </Col>} */}



                                            {system_Records_Issue_Challan_data.sale_method_option == 'group_type' &&
                                             <Col sm={12}>
                                                <FormGroup>

                                                    <Label for="sale_method">Sale Method</Label>
                                                    <Input type="select" className="custom-select"
                                                        name="sale_method" id="sale_method"
                                                        value={challanMasterData.sale_method || ''}
                                                        onChange={handleChange}
                                                    >
                                                        {/* <option value="">Select</option> */}
                                                        <option value="single_type">Single Type</option>
                                                        <option value="group_type">Group Type</option>
                                                    </Input>

                                                </FormGroup>
                                            </Col>}



                                            {challanMasterData.sale_method == "group_type" && 
                                            <Col sm={12}>
                                                <FormGroup > {/* Adjust width as needed */}
                                                    <Label for="item_name">Item Name</Label>
                                                    <Autocomplete
                                                        id="item_name"
                                                        name="item_name"
                                                        options={itemTable.map((option) => ({ id: option.id, label: option.item_name }))}
                                                        renderInput={(params) => <TextField {...params} size="small" />}
                                                        value={challanMasterData.item_name || ''}
                                                        onChange={handleChallanSingleItem}
                                                    // style={{ fontSize: 14 }}
                                                    />

                                                </FormGroup>
                                            </Col>}

                                            <Col sm={12}>
                                                <FormGroup>

                                                    <Label for="pcode">Party Name</Label>
                                                  
                                                    <Autocomplete
                                                        size="small"
                                                        autoHighlight
                                                        id="pcode"
                                                        name="pcode"
                                                        options={partyTable || []} // Ensure options are never undefined
                                                        getOptionLabel={(option) => `${option.name} - ${option.party_agr_code}-${option.party_company_name} - ${option.mobile_number}`} // Correct concatenation
                                                        renderInput={(params) => (
                                                            <TextField {...params} placeholder="Select Party Code" />
                                                        )}
                                                        renderOption={(props, option, { index }) => (
                                                            <li {...props} key={option.id || index}>
                                                                {`${option.name} - ${option.party_agr_code}- ${option.party_company_name}- ${option.mobile_number}`} {/* Correct concatenation */}
                                                            </li>
                                                        )}
                                                        value={partyTable.find(option => option.id === challanMasterData?.pcode) || null}
                                                        onChange={(event, value) => {
                                                            handleCusotmerName(event, value);
                                                        }}
                                                        disabled={!challanMasterData.vender_master_id || !challanMasterData.branch_master_id}
                                                        readOnly={singleItemSelectArray.length !== 0}
                                                        onInputChange={(event, value, reason) => {
                                                            if (reason === 'input') {
                                                                setSearchText(value);
                                                                setPage(1);
                                                                debouncedGetPartyData(value);

                                                                // getPartyData(value, 1, 100, false); // fetch next page only on typing
                                                            }
                                                        }}
                                                    />



                                                    {errorMessage.pname && (
                                                        <FormText color='danger'>
                                                            {errorMessage.pname}
                                                        </FormText>
                                                    )}

                                                </FormGroup>
                                            </Col>

                                            <Col sm={3}>
                                                <FormGroup>

                                                    <Label for="delivery_date">Delivery Date</Label>
                                                    <Input 
                                                    type="date" 
                                                    name="delivery_date" 
                                                    id="delivery_date" 
                                                    value={challanMasterData.delivery_date || ''} onChange={handleChange} />

                                                    {errorMessage.delivery_date && (
                                                        <FormText color='danger'>
                                                            {errorMessage.delivery_date}
                                                        </FormText>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                         


                                        </Row>

                                    </CardBody>


                                    {/* Challan Trans Master Table */}
                                    {
                                        // true
                                        billMethod == "aggrement"
                                        && <div>
                                            {editMode && <Col lg="12">
                                                <Card className='bg-white pd-10 card-box mb-30'>
                                                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
                                                        <div className="d-flex align-items-center">
                                                            <i className="bi bi-card-text mr-2"></i>
                                                            Challan Item
                                                        </div>


                                                        <Button color="primary" size="bg"
                                                            onClick={() => openAgrementCustomerModal()} style={{ margin: 5 }}
                                                            disabled={!challanMasterData.pname}
                                                        >
                                                            New Agmt Item
                                                        </Button>

                                                    </CardTitle>

                                                    <CardBody className="">



                                                        <Table bordered style={{ fontSize: "small" }} responsive>
                                                            <thead style={{ backgroundColor: "#f8f9fa" }}>
                                                                <tr>
                                                                    <th style={{ backgroundColor: "#d1e7dd" }}>ID</th>
                                                                    <th style={{ backgroundColor: "#d1e7dd" }}>Item Name</th>
                                                                    {System_Records_data[0]?.current_stock_yn == "yes" && <th style={{ backgroundColor: "#d1e7dd" }}>Current Stock</th>}
                                                                    <th style={{ backgroundColor: "#d1e7dd" }}>Bal Qty</th>
                                                                    <th style={{ backgroundColor: "#d1e7dd" }}>Issue Qty</th>
                                                                    <th style={{ backgroundColor: "#d1e7dd" }}>Action</th>
                                                                    {System_Records_data[0]?.issuied_qty == "yes" && <th style={{ backgroundColor: "#d1e7dd" }}>Issued Qty</th>}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {aggrementTable.length !== 0 ? (
                                                                    aggrementTable.map((item, index) => {
                                                                        return (
                                                                            <tr key={index} style={{ backgroundColor: index % 2 == 0 ? "#f2f2f2" : "#ffffff" }}>
                                                                                <th scope="row" style={{ backgroundColor: "#e9ecef" }}>{index + 1}</th>
                                                                                <td>
                                                                                    <Col style={{ width: 170 }}>
                                                                                        <Input
                                                                                            type="text"
                                                                                            value={item.item_name}
                                                                                            disabled={true}
                                                                                            style={{ fontSize: 14, backgroundColor: "#e9f5e9" }}
                                                                                        />
                                                                                    </Col>
                                                                                </td>
                                                                                {System_Records_data[0]?.current_stock_yn == "yes" && <td>
                                                                                    <Col style={{ width: 170, marginTop: 5, display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                                                        
                                                                                        <Input
                                                                                            type="number"
                                                                                            value={item.itemMaster?.total_stock}
                                                                                            disabled
                                                                                            style={{ fontSize: 14, backgroundColor: "#f8f9fa" }} // Light Gray Background
                                                                                        />
                                                                                    </Col>
                                                                                </td>}
                                                                                <td>
                                                                                    <Col style={{ width: 170 }}>
                                                                                        <Input
                                                                                            style={{ fontSize: 14, backgroundColor: "#fff3cd" }} // Light Yellow Background
                                                                                            type="text"
                                                                                            value={item.opening_qty + 0}
                                                                                            disabled
                                                                                        />
                                                                                    </Col>
                                                                                </td>
                                                                                <td>
                                                                                    <Col style={{ width: 170 }}>
                                                                                        <Input
                                                                                            style={{ fontSize: 14, backgroundColor: "#e2e3e5" }} // Light Gray
                                                                                            type="number"
                                                                                            value={item.issue_qty}
                                                                                            min="0"
                                                                                            onChange={(e) => handleItemChange(e, item.id, 'issue_qty')}
                                                                                        />
                                                                                    </Col>
                                                                                </td>
                                                                                <td style={{ display: "flex", flexDirection: "row" }}>
                                                                                    {System_Records_data[0]?.brokage_button == "yes" &&
                                                                                        <Button color="success" size="sm" style={{ margin: 2, backgroundColor: "#198754" }} onClick={() => openModal(item.id, item.item_name)}>
                                                                                            BKG
                                                                                        </Button>
                                                                                    }
                                                                                    {(item.mix_item_yes_no == "yes" && System_Records_data[0]?.mixed_button == "yes") &&
                                                                                        <Button color="success" size="sm"
                                                                                            onClick={() => openMixedDetailModal(item.item_code, item.item_name)}
                                                                                            style={{ backgroundColor: "#20c997" }} // Custom Green
                                                                                        >
                                                                                            MixDtl
                                                                                        </Button>
                                                                                    }
                                                                                </td>
                                                                                {System_Records_data[0]?.issuied_qty == "yes" && <td>
                                                                                    <Col style={{ width: 150 }}>
                                                                                        <Input
                                                                                            style={{ fontSize: 14, backgroundColor: "#f8d7da" }} // Light Red Background
                                                                                            type="text"
                                                                                            value={item.recv_qty}
                                                                                            onChange={(e) => handleItemChange(e, item.id, 'recv_qty')}
                                                                                        />
                                                                                    </Col>
                                                                                </td>}
                                                                            </tr>
                                                                        );
                                                                    })
                                                                )
                                                                    :
                                                                    (
                                                                        <>
                                                                            <tr>
                                                                                <td colSpan="7" style={{ textAlign: "center", padding: "10px", backgroundColor: "#f8d7da", fontWeight: "bold" }}>
                                                                                    Data Not Found
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    )


                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </CardBody>

                                                </Card>
                                            </Col>
                                            }

                                        </div>}

                                    {/* Challan Breakage Trans Master Table */}

                                    <CustomModal
                                        show={showMode}
                                        title={"this is edit mode"}
                                        onCancel={closeModal}
                                        onConfirm={confirmModal}
                                        content=<div>
                                            <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center">
                                                    <i className="bi bi-bell mr-2"></i>
                                                    Challan Breakage Form
                                                </div>
                                            </CardTitle>
                                            <CardBody>
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col sm="2">
                                                            <FormGroup>
                                                                <Label for={`rate`}>Rate</Label>
                                                                <Input
                                                                    type="number"
                                                                    name="rate"
                                                                    id={`rate`}
                                                                    value={challanBrokageDetail.rate || ''}
                                                                    onChange={(e) => handleChallanBrokageChange(e)}
                                                                />
                                                            </FormGroup>
                                                        </Col>

                                                        <Col sm="1">
                                                            <FormGroup>
                                                                <Label for={`qty`}>Qty</Label>
                                                                <Input
                                                                    type="number"
                                                                    name="qty"
                                                                    id={`qty`}
                                                                    value={challanBrokageDetail.qty || ''}
                                                                    onChange={(e) => handleChallanBrokageChange(e)}
                                                                />
                                                            </FormGroup>
                                                        </Col>

                                                        <Col sm="1">
                                                            <FormGroup>
                                                                <Label for={`amt`}>Amount</Label>
                                                                <Input
                                                                    type="number"
                                                                    name="amt"
                                                                    id={`amt`}
                                                                    value={challanBrokageDetail.amt || ''}
                                                                    onChange={(e) => handleChallanBrokageChange(e)}
                                                                />
                                                            </FormGroup>
                                                        </Col>

                                                        <Col sm="1">
                                                            <FormGroup>
                                                                <Label for={`narr`}>Narration</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="narr"
                                                                    id={`narr`}
                                                                    value={challanBrokageDetail.narr || ''}
                                                                    onChange={(e) => handleChallanBrokageChange(e)}
                                                                />
                                                            </FormGroup>
                                                        </Col>

                                                        <Col sm="1">
                                                            <FormGroup>
                                                                <Label for={`damage`}>Damage</Label>
                                                                <Input
                                                                    type="number"
                                                                    name="damage"
                                                                    id={`damage`}
                                                                    value={challanBrokageDetail.damage || ''}
                                                                    onChange={(e) => handleChallanBrokageChange(e)}
                                                                />
                                                            </FormGroup>
                                                        </Col>

                                                        <Col sm="1">
                                                            <FormGroup>
                                                                <Label for={`missing`}>Missing</Label>
                                                                <Input
                                                                    type="number"
                                                                    name="missing"
                                                                    id={`missing`}
                                                                    value={challanBrokageDetail.missing || ''}
                                                                    onChange={(e) => handleChallanBrokageChange(e)}
                                                                />
                                                            </FormGroup>
                                                        </Col>

                                                        <Col sm="2">
                                                            <FormGroup>
                                                                <Label for={`item_name`}>Item Name</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="item_name"
                                                                    id={`item_name`}
                                                                    value={challanBrokageDetail.item_name || ''}
                                                                    onChange={(e) => handleChallanBrokageChange(e)}
                                                                />

                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="2" style={{ marginTop: 30 }}>
                                                            <FormGroup>
                                                                <Button color="primary" onClick={AddChallanBrokageData}>Add More Brokage Detail</Button>
                                                            </FormGroup>
                                                        </Col>

                                                    </Row>
                                                </div>
                                            </CardBody>

                                            <div>
                                                <CardBody className="">
                                                    <Table striped>
                                                        <thead>
                                                            <tr>
                                                                <th>S. no.</th>
                                                                <th>Rate</th>
                                                                <th>Qty</th>
                                                                <th>Amt</th>
                                                                <th>Narr</th>
                                                                <th>Damage</th>
                                                                <th>Missing</th>
                                                                <th>Item Name</th>
                                                                <th>Action</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {challanBrokageModelTable.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.rate}</td>
                                                                    <td>{item.qty}</td>
                                                                    <td>{item.amt}</td>
                                                                    <td>{item.narr}</td>
                                                                    <td>{item.damage}</td>
                                                                    <td>{item.missing}</td>
                                                                    <td>{item.item_name}</td>
                                                                    <td>
                                                                        <Button color="danger" onClick={() => onRemoveChallanBrokageData(index)}>
                                                                            Remove
                                                                        </Button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </CardBody>
                                            </div>
                                        </div>
                                    />



                                    {/*  Challan Item Mixed Detail  */}

                                    <CustomModal
                                        show={showMixedModel}
                                        title={"this is edit mode"}
                                        onCancel={closedMixedDetailModal}
                                        onConfirm={confirmMixedDetailModal}
                                        content=<div>
                                            <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center">
                                                    <i className="bi bi-bell mr-2"></i>
                                                    Item Mixed Detail
                                                </div>
                                            </CardTitle>


                                            <div>
                                                <CardBody className="">
                                                    <Table striped>
                                                        <thead>
                                                            <tr>
                                                                <th>S. no.</th>
                                                                <th>Item Master</th>
                                                                <th>Qty</th>
                                                                <th>Item Rate</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {showMixedList.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.item_name}</td>
                                                                    <td>{item.item_qty}</td>
                                                                    <td>{item.item_rate}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </CardBody>
                                            </div>
                                        </div>
                                    />

                                    {/* ==============================  Single Item Entry ========================= */}

                                    {
                                        // true
                                        billMethod == "single1"
                                        &&
                                        <>
                                            {editMode &&
                                                <Col lg="12">
                                                    <Card className='bg-white pd-10 card-box mb-30'>

                                                        <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center">
                                                            <i className="bi bi-card-text mr-2"></i>
                                                            Single Item Details
                                                            <Row className="ml-auto" style={{ marginRight: '10px' }}>
                                                                <Button color="primary" size="bg" onClick={() => { openSingleItemModel() }}>Add New Item</Button>
                                                            </Row>
                                                        </CardTitle>

                                                        <div>
                                                            <Col>
                                                                <FormGroup style={{ padding: 10 }} >
                                                                    <Label style={{ fontSize: 14 }} for="item_name">Item Name</Label>
                                                                    <Autocomplete
                                                                        id="item_name"
                                                                        name="item_name"
                                                                        options={itemTable.map((option) => ({ id: option.id, label: option.item_name }))}
                                                                        renderInput={(params) => <TextField {...params} size="small" />}
                                                                        value={singleItemSelect.item_name || ''}
                                                                        onChange={handleSingleItem}
                                                                        style={{ fontSize: 14 }}
                                                                    // disable={!challanMasterData.pname}
                                                                    />
                                                                    {/* {itemErrorMessage.item_name && (
                                                                        <FormText color="danger">{itemErrorMessage.item_name}</FormText>
                                                                    )} */}
                                                                </FormGroup>
                                                            </Col>
                                                            <Table striped>
                                                                <tbody >
                                                                    <tr style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                                        {system_Records_Issue_Challan_data?.hsn_code_yn == "yes" &&
                                                                            <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                                <FormGroup>
                                                                                    <Label style={{ fontSize: 14 }}
                                                                                        for="item_hsn_code_one_pc">HSN Code</Label>
                                                                                    <Input
                                                                                        id="item_hsn_code_one_pc"
                                                                                        name="item_hsn_code_one_pc"
                                                                                        type="text"
                                                                                        // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                        value={singleItemSelect.item_hsn_code_one_pc}
                                                                                        disabled
                                                                                        style={{ fontSize: 14 }}

                                                                                    />

                                                                                </FormGroup>
                                                                            </td>}


                                                                        {system_Records_Issue_Challan_data?.packing_type_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }}
                                                                                    for="item_packing_type_one_pc">Packing Type</Label>
                                                                                <Input
                                                                                    id="item_packing_type_one_pc"
                                                                                    name="item_packing_type_one_pc"
                                                                                    type="text"
                                                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_packing_type_one_pc}
                                                                                    disabled
                                                                                    style={{ fontSize: 14 }}

                                                                                />

                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.scheme_type_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }}
                                                                                    for="item_scheme_type_one_pc">Scheme Type</Label>
                                                                                <Input
                                                                                    id="item_scheme_type_one_pc"
                                                                                    name="item_scheme_type_one_pc"
                                                                                    type="select" className="custom-select"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_scheme_type_one_pc}
                                                                                    style={{ fontSize: 14 }}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {helperMasterSingleItem.length != 0 && helperMasterSingleItem.map((option) => (
                                                                                        <option key={option.id} value={option.field_data}>
                                                                                            {option.field_data}
                                                                                        </option>
                                                                                    ))}
                                                                                </Input>

                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.remarks_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }}
                                                                                    for="item_remarks_one_pc">Remarks</Label>
                                                                                <Input
                                                                                    id="item_remarks_one_pc"
                                                                                    name="item_remarks_one_pc"
                                                                                    type="text"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_remarks_one_pc}
                                                                                    style={{ fontSize: 14 }}

                                                                                />
                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.purchase_rate_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }} for="item_purchase_one_pc">Purchase Rate</Label>
                                                                                <Input
                                                                                    id="item_purchase_one_pc"
                                                                                    name="item_purchase_one_pc"
                                                                                    type="text"
                                                                                    // onChange={(e) => { onChangeItemHandle(e) }}
                                                                                    value={singleItemSelect?.item_purchase_one_pc || ""}
                                                                                    disabled
                                                                                    style={{ fontSize: 14 }}
                                                                                />
                                                                              
                                                                            </FormGroup>
                                                                        </td>}

                                                                        {/* </tr>

                                                                        <tr> */}


                                                                        {system_Records_Issue_Challan_data?.sale_rate_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }} for="rent_rate">Rate</Label>
                                                                                <Input
                                                                                    id="rent_rate"
                                                                                    name="rent_rate"
                                                                                    type="text"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect?.rent_rate || ""}
                                                                                    style={{ fontSize: 14 }}
                                                                                />
                                                                            </FormGroup>
                                                                        </td>}


                                                                        {system_Records_Issue_Challan_data?.profit_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }} for="item_profit_one_pc">Profit</Label>
                                                                                <Input
                                                                                    id="item_profit_one_pc"
                                                                                    name="item_profit_one_pc"
                                                                                    type="text"
                                                                                    value={singleItemSelect?.item_profit_one_pc || ""}
                                                                                    disabled
                                                                                    style={{ fontSize: 14 }}
                                                                                />
                                                                            </FormGroup>
                                                                        </td>}



                                                                        {system_Records_Issue_Challan_data?.issue_qty_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }} for="issue_qty">Qty</Label> {singleItemSelect.item_code && <Label style={{ color: "red" }}>(mandatory)</Label>}
                                                                                <Input
                                                                                    id="issue_qty"
                                                                                    name="issue_qty"
                                                                                    type="number"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect?.issue_qty || ""}
                                                                                    style={{ fontSize: 14 }}
                                                                                />
                                                                              
                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.discount_percentage_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }} for="item_discount_percentage_one_pc">Discount %</Label>
                                                                                <Input
                                                                                    id="item_discount_percentage_one_pc"
                                                                                    name="item_discount_percentage_one_pc"
                                                                                    type="number"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect?.item_discount_percentage_one_pc || ""}
                                                                                    style={{ fontSize: 14 }}

                                                                                />
                                                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                    <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                )} */}
                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.discount_amount_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }} for="item_discount_amount_one_pc_one_pc">Discount Amt</Label>
                                                                                <Input
                                                                                    id="item_discount_amount_one_pc"
                                                                                    name="item_discount_amount_one_pc"
                                                                                    type="number"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect?.item_discount_amount_one_pc || ""}
                                                                                    style={{ fontSize: 14 }}
                                                                                    disabled
                                                                                />
                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.discount_rate_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }} for="item_discount_rate_one_pc">Discount Rate</Label>
                                                                                <Input
                                                                                    id="item_discount_rate_one_pc"
                                                                                    name="item_discount_rate_one_pc"
                                                                                    type="number"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect?.item_discount_rate_one_pc || ""}
                                                                                    style={{ fontSize: 14 }}
                                                                                    disabled

                                                                                />
                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.grand_total_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }} for="item_gross_amount_one_pc">Grs. Tot</Label>
                                                                                <Input
                                                                                    id="item_gross_amount_one_pc"
                                                                                    name="item_gross_amount_one_pc"
                                                                                    type="text"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_gross_amount_one_pc}
                                                                                    disabled
                                                                                    style={{ fontSize: 14 }}

                                                                                />
                                                                            </FormGroup>
                                                                        </td>}


                                                                        {system_Records_Issue_Challan_data?.gst_percentage_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }} for="item_gst_percenatge_one_pc">Gst %</Label>
                                                                                <Input
                                                                                    id="item_gst_percenatge_one_pc"
                                                                                    name="item_gst_percenatge_one_pc"
                                                                                    type="text"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_gst_percenatge_one_pc}
                                                                                    style={{ fontSize: 14 }}

                                                                                />
                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.gst_amount_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }} for="item_gst_amt_one_pc">Gst Amt</Label>
                                                                                <Input
                                                                                    id="item_gst_amt_one_pc"
                                                                                    name="item_gst_amt_one_pc"
                                                                                    type="text"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_gst_amt_one_pc}
                                                                                    style={{ fontSize: 14 }}
                                                                                    disabled

                                                                                />
                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.gst_rate_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label
                                                                                    style={{ fontSize: 14 }}
                                                                                    for="item_gst_rate_one_pc">Gst Rate</Label>
                                                                                <Input
                                                                                    id="item_gst_rate_one_pc"
                                                                                    name="item_gst_rate_one_pc"
                                                                                    type="text"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_gst_rate_one_pc}
                                                                                    disabled
                                                                                    style={{ fontSize: 14 }}

                                                                                />
                                                                            </FormGroup>
                                                                        </td>}
                                                                      

                                                                        {system_Records_Issue_Challan_data?.rate_after_gst_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label
                                                                                    style={{ fontSize: 14 }}
                                                                                    for="item_rate_after_gst_one_pc">Rate After Gst</Label>
                                                                                <Input
                                                                                    id="item_rate_after_gst_one_pc"
                                                                                    name="item_rate_after_gst_one_pc"
                                                                                    type="text"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_rate_after_gst_one_pc}
                                                                                    disabled
                                                                                    style={{ fontSize: 14 }}

                                                                                />
                                                                      
                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.total_amount_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }}
                                                                                    for="total_amount_with_gst_one_pc">Tot Amt</Label>
                                                                                <Input
                                                                                    id="total_amount_with_gst_one_pc"
                                                                                    name="total_amount_with_gst_one_pc"
                                                                                    type="text"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.total_amount_with_gst_one_pc}
                                                                                    disabled
                                                                                    style={{ fontSize: 14 }}

                                                                                />
                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.total_profit_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }}
                                                                                    for="profit_amount_one_pc">Tot Profit</Label>
                                                                                <Input
                                                                                    id="profit_amount_one_pc"
                                                                                    name="profit_amount_one_pc"
                                                                                    type="text"
                                                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.profit_amount_one_pc}
                                                                                    disabled
                                                                                    style={{ fontSize: 14 }}

                                                                                />

                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.total_weight_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }}
                                                                                    for="item_weight_one_pc">Tot Wt</Label>
                                                                                <Input
                                                                                    id="item_weight_one_pc"
                                                                                    name="item_weight_one_pc"
                                                                                    type="text"
                                                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_weight_one_pc || ""}
                                                                                    // value={singleItemSelect.issue_qty ? singleItemSelect.item_weight_one_pc * singleItemSelect.issue_qty :singleItemSelect.item_weight_one_pc  }
                                                                                    disabled
                                                                                    style={{ fontSize: 14 }}

                                                                                />

                                                                            </FormGroup>
                                                                        </td>}




                                                                        {system_Records_Issue_Challan_data?.current_stock_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }}
                                                                                    for="">Current Stock</Label>
                                                                                <Input
                                                                                    id=""
                                                                                    name=""
                                                                                    type="text"
                                                                                    value={singleItemSelect.item_current_stock || ""}
                                                                                    disabled
                                                                                    style={{ fontSize: 14 }}
                                                                                />
                                                                            </FormGroup>
                                                                        </td>}

                                                                        {/* </tr>

                                                                        <tr> */}
                                                                        {system_Records_Issue_Challan_data?.balance_qty_yn == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }}
                                                                                    for="">Bal Qty</Label>
                                                                                <Input
                                                                                    id=""
                                                                                    name=""
                                                                                    type="text"
                                                                                    value={singleItemSelect.opening_qty || ""}
                                                                                    disabled
                                                                                    style={{ fontSize: 14 }}
                                                                                />
                                                                            </FormGroup>
                                                                        </td>}



                                                                        {/*  add new key */}
                                                                        {system_Records_Issue_Challan_data?.warranty_period == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }} for="">Warranty Period</Label>
                                                                                <Input
                                                                                    id="item_warranty_period"
                                                                                    name="item_warranty_period"
                                                                                    type="select" className="custom-select"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_warranty_period || ""}
                                                                                    style={{ fontSize: 14 }}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {helperMasterSingleItemWarrantyPeriod.length != 0 && helperMasterSingleItemWarrantyPeriod.map((option) => (
                                                                                        <option key={option.id} value={option.field_data}>
                                                                                            {option.field_data}
                                                                                        </option>
                                                                                    ))}
                                                                                </Input>
                                                                            </FormGroup>
                                                                        </td>}

                                                                        {system_Records_Issue_Challan_data?.warranty_mode == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }}
                                                                                    for="">Warranty Mode</Label>
                                                                                <Input
                                                                                    id="item_warranty_mode"
                                                                                    name="item_warranty_mode"
                                                                                    type="select" className="custom-select"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_warranty_mode || ""}
                                                                                    style={{ fontSize: 14 }}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    <option value="online">Online</option>
                                                                                    <option value="offline">Offline</option>

                                                                                </Input>
                                                                            </FormGroup>
                                                                        </td>}



                                                                        {system_Records_Issue_Challan_data?.service_visit_count == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }}
                                                                                    for="">Service Visit Count</Label>
                                                                                <Input
                                                                                    id="item_warranty_visit_count"
                                                                                    name="item_warranty_visit_count"
                                                                                    type="text"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_warranty_visit_count || ""}
                                                                                    style={{ fontSize: 14 }}
                                                                                />
                                                                            </FormGroup>
                                                                        </td>
                                                                        }

                                                                        {system_Records_Issue_Challan_data?.warranty_expiry_date == "yes" && <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            <FormGroup>
                                                                                <Label style={{ fontSize: 14 }}
                                                                                    for="">Warranty Expiry Date</Label>
                                                                                <Input
                                                                                    id="item_warranty_expiry_date"
                                                                                    name="item_warranty_expiry_date"
                                                                                    type="date"
                                                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                                                    value={singleItemSelect.item_warranty_expiry_date?.split('T')[0] || ""}
                                                                                    style={{ fontSize: 14 }}
                                                                                />
                                                                            </FormGroup>
                                                                        </td>}


                                                                        <td style={{ width: 180, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 0, boxSizing: 'border-box' }}>
                                                                            {system_Records_Issue_Challan_data?.extra_detail_button == "yes" && <Button type="button" className="mt-2" color="success"
                                                                                disabled={!singleItemSelect.item_name}
                                                                                onClick={() => openSingleItemExtraDetailModel(singleItemSelect.id, singleItemSelect.item_name)}>Add Extra Detail</Button>}

                                                                            <Button type="button" className="mt-2" color="primary"
                                                                                disabled={!singleItemSelect.issue_qty}
                                                                                onClick={() => AddSingleItemSelect()}> {singleItemEditMode ? "Update" : "Save"}</Button>

                                                                            {system_Records_Issue_Challan_data?.warranty_button == "yes" && <Button type="button" className="mt-2" color="primary"
                                                                                disabled={(!singleItemSelect.issue_qty && !singleItemSelect.item_warranty_visit_count)}
                                                                                onClick={() => OpenWarrantyModel(singleItemSelect.item_code, singleItemSelect.item_name)}
                                                                            >Add Warranty</Button>}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </Table>


                                                            {singleItemSelectArray.length != 0 && <CardBody className="" responsive>
                                                                <Table hover striped responsive>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>S. no.</th>
                                                                            <th>Item Name</th>
                                                                            <th>Purhase Rate</th>
                                                                            <th>Rate</th>
                                                                            <th>Profit</th>
                                                                            <th>Qty</th>
                                                                            <th>Discount</th>
                                                                            <th>Gross Total</th>
                                                                            <th>Gst%</th>
                                                                            <th>Gst Rate</th>
                                                                            <th>Total Amount</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {singleItemSelectArray.map((item, index) => (
                                                                            <tr key={index}>
                                                                                <th scope="row">{index + 1}</th>
                                                                                <td>{item.item_name}</td>
                                                                                <td>{item?.item_purchase_one_pc}</td>
                                                                                <td>{item?.rent_rate}</td>
                                                                                <td>{item?.item_profit_one_pc}</td>
                                                                                <td>{item?.issue_qty}</td>

                                                                                <td>{isNumber(item.item_discount_percentage_one_pc) ? item.item_discount_percentage_one_pc.toFixed(2) : item.item_discount_percentage_one_pc}</td>
                                                                                <td>{isNumber(item?.item_gross_amount_one_pc) ? item?.item_gross_amount_one_pc.toFixed(2) : item?.item_gross_amount_one_pc}</td>
                                                                                <td>{isNumber(item?.item_gst_percenatge_one_pc) ? item?.item_gst_percenatge_one_pc.toFixed(2) : item?.item_gst_percenatge_one_pc}</td>
                                                                                <td>{isNumber(item?.item_gst_rate_one_pc) ? item?.item_gst_rate_one_pc.toFixed(2) : item?.item_gst_rate_one_pc}</td>
                                                                                <td>{isNumber(item?.total_amount_with_gst_one_pc) ? item?.total_amount_with_gst_one_pc.toFixed(2) : item?.total_amount_with_gst_one_pc}</td>

                                                                                <td>
                                                                                    <Button color="danger" size="bg"
                                                                                        onClick={() => RemoveSingleItemSelect(item.id)}
                                                                                    >
                                                                                        Delete
                                                                                    </Button>

                                                                                    <Button color="success" size="bg"
                                                                                        onClick={() => EditSingleItemSelect(item.id)}
                                                                                        disabled={singleItemEditMode}
                                                                                    >
                                                                                        Edit
                                                                                    </Button>
                                                                                </td>

                                                                                <td>
                                                                                    {System_Records_data[0]?.extra_detail_button == "yes" && <Button color="primary" size="bg"
                                                                                        onClick={() => openSingleItemExtraDetailModel(item.item_code, item.item_name)}
                                                                                    >
                                                                                        View
                                                                                    </Button>}
                                                                                    {System_Records_data[0]?.warranty_button == "yes" && <Button color="primary" size="bg"
                                                                                        onClick={() => viewWarrantyModel(item.item_code, item.item_name, index)}
                                                                                    >
                                                                                        Warranty
                                                                                    </Button>}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </Table>
                                                            </CardBody>}
                                                        </div>
                                                    </Card>
                                                </Col>
                                            }
                                        </>
                                    }



                                    {billMethod == "single" && editMode && <SingleItemArray
                                        itemTable={itemTable}
                                        helperMasterSingleItem={helperMasterSingleItem}
                                        partyMasterName={partyMasterName}
                                        partyMasterId={partyMasterId}
                                        singleItemSelectArray={singleItemSelectArray}
                                        setSingleItemSelectArray={setSingleItemSelectArray}
                                        System_Records_receipted_data={system_Records_Issue_Challan_data}
                                        openSingleItemExtraDetailModel={openSingleItemExtraDetailModel}
                                        OpenWarrantyModel={OpenWarrantyModel}
                                        setDeletesingleItemSelectArray={setDeletesingleItemSelectArray}
                                        openSingleItemModel={openSingleItemModel}
                                        IrFlag={irFlagState}
                                        UpdateChallanMasterData={UpdateChallanMasterData}
                                        errorMessage={errorMessage}
                                        partyTable={partyTable}

                                        nextIrFlag={irFlagState}
                                        nextIrFlagDetail={irFlagDetailState}
                                        nextPartyOption={false}
                                        setRemoveNextChallanArray={setRemoveNextChallanArray}
                                        challanMasterData={challanMasterData}

                                    // handleSingleItem={handleSingleItem}
                                    />}

                                    {(aggrementTable.length != 0 || singleItemSelectArray.length != 0) && <div>

                                        {/* ============================  Address Detail =================================*/}

                                        {system_Records_Issue_Challan_data.chl_acc_addr_yn == "yes" && <div>
                                            {editMode &&
                                                <>
                                                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                                                        style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}
                                                        onClick={() => toggleAccordion(1)}
                                                    >
                                                        <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "#800080" }}>
                                                            <i className="bi bi-bell mr-2"></i>
                                                            Address Detail
                                                        </div>
                                                        {openAccordion === 1 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}

                                                    </CardTitle>
                                                    <Collapse isOpen={openAccordion === 1}>

                                                        <CardBody>

                                                            <Row className="mb-2">
                                                                {/* <Col sm="4"> */}
                                                                <FormGroup>
                                                                    <Label for="address">Select Address</Label>


                                                                    <Autocomplete
                                                                        id="address"
                                                                        size='small'
                                                                        options={filteredData.length > 0 ? filteredData[0].partyAddressTransMaster : []} // Passing the entire partyAddressTransMaster array
                                                                        getOptionLabel={(option) => `${option?.party_address_description}, ${option?.party_address_1}, ${option?.party_address_2}, ${option?.party_state}, ${option?.party_city}${option?.party_pincode}`} // Customize the displayed label
                                                                        renderInput={(params) => <TextField {...params} />}
                                                                        // value={challanMasterData.pname || ''}
                                                                        onChange={handleAddressName}
                                                                    />
                                                                </FormGroup>
                                                                {/* </Col> */}

                                                                <Col sm="12">
                                                                    <FormGroup>

                                                                        <Label for="addr_type">Address Type</Label>
                                                                        <Input type="text" name="addr_type" id="addr_type" value={challanMasterData.addr_type || ''} onChange={handleChange} />
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col sm="12">
                                                                    <FormGroup>

                                                                        <Label for="add1">Address Line 1</Label>
                                                                        <Input type="text" name="add1" id="add1" value={challanMasterData.add1 || ''} onChange={handleChange} />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col sm="12">
                                                                    <FormGroup>

                                                                        <Label for="add2">Address Line 2</Label>
                                                                        <Input type="text" name="add2" id="add2" value={challanMasterData.add2 || ''} onChange={handleChange} />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col sm="12">
                                                                    <FormGroup>

                                                                        <Label for="add3_location">Location</Label>
                                                                        <Input type="text" name="add3_location" id="add3_location" value={challanMasterData.add3_location || ''} onChange={handleChange} />
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col sm="4">

                                                                    <FormGroup>
                                                                        <Label for="add5_state">State:</Label>

                                                                        <Input type="select" className="custom-select"
                                                                            name="add5_state"
                                                                            id="add5_state"
                                                                            value={challanMasterData.add5_state}
                                                                            onChange={handleChange}

                                                                        >
                                                                            <option value="">Select</option>
                                                                            {stateTable.map((option) => (
                                                                                <option key={option.state_Id} value={option.state_Name}>
                                                                                    {option.state_Name}
                                                                                </option>
                                                                            ))}
                                                                        </Input>
                                                                    </FormGroup>
                                                                </Col>


                                                                <Col sm="4">
                                                                    <FormGroup>

                                                                        <Label for="add4_city">City</Label>
                                                                  
                                                                        <Input

                                                                            type="select" className="custom-select"
                                                                            name="add4_city"
                                                                            id="add4_city"
                                                                            value={challanMasterData.add4_city}
                                                                            onChange={handleChange}
                                                                        >
                                                                            <option>Select City</option>
                                                                            {
                                                                                cityTable
                                                                                    .filter(city => city.state_name == challanMasterData.add5_state)
                                                                                    .map(data => (
                                                                                        <option key={data.id} value={data.add4_city}>
                                                                                            {data.city_name}
                                                                                        </option>
                                                                                    ))
                                                                            }
                                                                        </Input>
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col sm="4">
                                                                    <FormGroup>

                                                                        <Label for="add6_pincode">Pincode</Label>
                                                                        <Input type="number" name="add6_pincode" id="add6_pincode" value={challanMasterData.add6_pincode || ''} onChange={handleChange} />
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col sm="4">
                                                                    <FormGroup>
                                                                        <Label for="addr_gst_type">GST Type:</Label>
                                                                        <Input type="text" name="addr_gst_type" id="addr_gst_type" value={challanMasterData.addr_gst_type} onChange={handleChange} disabled />
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col sm="4">
                                                                    <FormGroup>
                                                                        <Label for="state_code">State Code:</Label>
                                                                        <Input type="text" name="state_code" id="state_code" value={challanMasterData.state_code} onChange={handleChange} />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col sm="4">
                                                                    <FormGroup>
                                                                        <Label for="gstno">GST Number:</Label>
                                                                        <Input type="text" name="gstno" id="gstno" value={challanMasterData.gstno} onChange={handleChange} />
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Collapse>
                                                </>
                                            }
                                        </div>}

                                        {/* Delivery Detail */}

                                        {system_Records_Issue_Challan_data.chl_acc_bill_ext_yn == "yes" && <div>
                                            {editMode &&
                                                <>

                                                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                                                        style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}
                                                        onClick={() => toggleAccordion(2)}
                                                    >
                                                        <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "orange" }}>
                                                            <i className="bi bi-bell mr-2"></i>
                                                            Billing Extra Detail
                                                        </div>
                                                        {openAccordion === 2 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}

                                                    </CardTitle>
                                                    <Collapse isOpen={openAccordion === 2}>

                                                        <CardBody>

                                                            <div>

                                                                <Col sm={12}>
                                                                    <FormGroup>

                                                                        <Label for="remark_note">Remark Note</Label>
                                                                        <Input type="text" name="remark_note" id="remark_note" value={challanMasterData.remark_note || ''} onChange={handleChange} />
                                                                    </FormGroup>
                                                                </Col>

                                                                <Row>
                                                                    <Col sm={4}>
                                                                        <FormGroup>
                                                                            <Label for="cart_po_date">PO. Date</Label>
                                                                            <Input type="date" name="cart_po_date" id="cart_po_date"
                                                                                value={challanMasterData.cart_po_date?.split('T')[0]} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col sm={4}>
                                                                        <FormGroup>
                                                                            <Label for="cart_po_number">PO. No.</Label>
                                                                            <Input type="text" name="cart_po_number" id="cart_po_number" value={challanMasterData.cart_po_number} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col sm={4}>
                                                                        <FormGroup>

                                                                            <Label for="contact_prs">Contact Person Name</Label>
                                                                            <Input type="text" name="contact_prs" id="contact_prs" value={challanMasterData.contact_prs || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                                <Row>


                                                                    <Col sm={4}>
                                                                        <FormGroup>

                                                                            <Label for="contact_prs_ph_no">Contact Person Phone No</Label>
                                                                            <Input type="number" name="contact_prs_ph_no" id="contact_prs_ph_no" value={challanMasterData.contact_prs_ph_no || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>

                                                                    <Col sm={4}>
                                                                        <FormGroup>

                                                                            <Label for="contact_prs_whts_no">Contact Person Whatsapp No</Label>
                                                                            <Input type="number" name="contact_prs_whts_no" id="contact_prs_whts_no" value={challanMasterData.contact_prs_whts_no || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col sm={4}>
                                                                        <FormGroup>

                                                                            <Label for="driver_name">Driver Name</Label>
                                                                            <Input type="text" name="driver_name" id="driver_name" value={challanMasterData.driver_name || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>


                                                                </Row>
                                                                <Row>

                                                                    <Col sm={4}>
                                                                        <FormGroup>

                                                                            <Label for="dl_no">DL No</Label>
                                                                            <Input type="text" name="dl_no" id="dl_no" value={challanMasterData.dl_no || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col sm={4}>
                                                                        <FormGroup>

                                                                            <Label for="vehicleno">Vehicle No</Label>
                                                                            <Input type="text" name="vehicleno" id="vehicleno" value={challanMasterData.vehicleno || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>


                                                                    <Col sm={4}>
                                                                        <FormGroup>

                                                                            <Label for="gr_no">GR No</Label>
                                                                            <Input type="text" name="gr_no" id="gr_no" value={challanMasterData.gr_no || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>

                                                                </Row>
                                                                <Row>


                                                                    <Col sm={4}>
                                                                        <FormGroup>

                                                                            <Label for="permit_no">Permit No</Label>
                                                                            <Input type="text" name="permit_no" id="permit_no" value={challanMasterData.permit_no || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                   
                                                                    <Col sm={4}>
                                                                        <FormGroup>

                                                                            <Label for="reverse_charge">Reverse Charge</Label>
                                                                            <Input type="select" className="custom-select"
                                                                                name="reverse_charge"
                                                                                id="reverse_charge"
                                                                                value={challanMasterData.reverse_charge || ''}
                                                                                onChange={handleChange}
                                                                            >
                                                                                <option value="">Select</option>
                                                                                <option value="yes">Yes</option>
                                                                                <option value="no">No</option>

                                                                            </Input>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col xl={4}>
                                                                        <FormGroup>

                                                                            <Label for="electronic_ref_no">Electr. Ref No(ewaybillno)</Label>
                                                                            <Input type="text" name="electronic_ref_no" id="electronic_ref_no" value={challanMasterData.electronic_ref_no || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>


                                                                </Row>
                                                                <Row>

                                                                    <Col xl={4}>
                                                                        <FormGroup>

                                                                            <Label for="station">Station</Label>
                                                                            <Input type="text" name="station" id="station" value={challanMasterData.station || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>

                                                                    {system_Records_Issue_Challan_data.bill_delivery_to_yn == "yes" && <Col xl={4}>
                                                                        <FormGroup>

                                                                            <Label for="bill_delivery_to">Bill Delivery To </Label>
                                                                            <Input type="text" name="bill_delivery_to" id="bill_delivery_to" value={challanMasterData.bill_delivery_to || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>}

                                                                    {system_Records_Issue_Challan_data.bill_receive_by_yn == "yes" && <Col xl={4}>
                                                                        <FormGroup>

                                                                            <Label for="bill_receive_by">Bill Receive By</Label>
                                                                            <Input type="text" name="bill_receive_by" id="bill_receive_by" value={challanMasterData.bill_receive_by || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>}
                                                                </Row>


                                                            </div>
                                                        </CardBody>
                                                    </Collapse>
                                                </>
                                            }
                                        </div>}


                                        {/* Transport Detail */}

                                        {system_Records_Issue_Challan_data.chl_acc_trans_yn == "yes" && <div>
                                            {editMode &&
                                                <>

                                                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                                                        style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}
                                                        onClick={() => toggleAccordion(3)}
                                                    >
                                                        <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "#1ba8f0" }}>
                                                            <i className="bi bi-bell mr-2"></i>
                                                            Transporter Detail
                                                        </div>
                                                        {openAccordion === 3 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}

                                                    </CardTitle>
                                                    <Collapse isOpen={openAccordion === 3}>

                                                        <CardBody>

                                                            <div>
                                                             
                                                                <Col sm={12}>
                                                                    <FormGroup>


                                                                        <Label htmlFor="myBrowser">Transporter Name</Label>
                                                                        <Input list="browsers" id="myBrowser" name="transport"
                                                                            placeholder="Type or select a transporter"
                                                                            value={challanMasterData.transporter_name || ''}
                                                                            onChange={handleChange}
                                                                        />
                                                                        <datalist id="browsers">
                                                                            {partyTable.map((option) => (
                                                                                <option key={option.id} value={option.name}>
                                                                                    {option.name}
                                                                                </option>
                                                                            ))}
                                                                        </datalist>
                                                                    </FormGroup>



                                                                </Col>

                                                                <Row>
                                                                    <Col sm={6}>
                                                                        <FormGroup>
                                                                            <Label for="cart_mobile_no">Mobile No.</Label>
                                                                            <Input type="text" name="cart_mobile_no" id="cart_mobile_no"
                                                                                value={challanMasterData.cart_mobile_no} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <FormGroup>
                                                                            <Label for="cart_email">Email</Label>
                                                                            <Input type="text" name="cart_email" id="cart_email"
                                                                                value={challanMasterData.cart_email} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>


                                                                </Row>


                                                                <Row>
                                                                    <Col sm={3}>
                                                                        <FormGroup>
                                                                            <Label for="cart_fraight_topay_paid">Freight/To pay/Paid</Label>
                                                                            <Input type="select" className="custom-select" name="cart_fraight_topay_paid" id="cart_fraight_topay_paid" value={challanMasterData.cart_fraight_topay_paid} onChange={handleChange}>
                                                                                <option value="">Select</option>
                                                                                <option value="topay">To pay</option>
                                                                                <option value="paid">Paid</option>
                                                                            </Input>
                                                                        </FormGroup>
                                                                    </Col>

                                                                    <Col sm={3}>
                                                                        <FormGroup>
                                                                            <Label for="trip_no">Trip No</Label>
                                                                            <Input type="number" name="trip_no" id="trip_no" value={challanMasterData.trip_no || ''} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <FormGroup>
                                                                            <Label for="cart_amt_maintain_yn">Maintain Accounting</Label>
                                                                            <Input type="select" className="custom-select"
                                                                                name="cart_amt_maintain_yn"
                                                                                id="cart_amt_maintain_yn"
                                                                                value={challanMasterData.cart_amt_maintain_yn}
                                                                                onChange={handleChange} >
                                                                                <option>Select</option>
                                                                                <option value="yes">Yes</option>
                                                                                <option value="no">No</option>

                                                                            </Input>
                                                                        </FormGroup>

                                                                    </Col>

                                                                    <Col sm={3}>
                                                                        <FormGroup>
                                                                            <Label for="cart_transporter_cartage">Transporter cartage in Bill</Label>
                                                                            <Input type="select" className="custom-select"
                                                                                name="cart_transporter_cartage"
                                                                                id="cart_transporter_cartage"
                                                                                value={challanMasterData.cart_transporter_cartage}
                                                                                onChange={handleChange} >
                                                                                <option>Select</option>
                                                                                <option value="yes">Yes</option>
                                                                                <option value="no">No</option>

                                                                            </Input>
                                                                        </FormGroup>

                                                                    </Col>



                                                                </Row>
                                                                <Row>

                                                                    <Col sm={3}>
                                                                        <FormGroup>
                                                                            <Label for="cart_amt_transporter">Cartage Amount</Label>
                                                                            <Input type="number" name="cart_amt_transporter" id="cart_amt_transporter" value={challanMasterData.cart_amt_transporter} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <FormGroup>
                                                                            {/* Freight/Labour */}
                                                                            <Label for="cart_per_tax_transporter">Cartage Gst %</Label>
                                                                            <Input type="number" name="cart_per_tax_transporter" id="cart_per_tax_transporter" value={challanMasterData.cart_per_tax_transporter} onChange={handleChange} />
                                                                        </FormGroup>
                                                                    </Col>

                                                                    <Col sm={3}>
                                                                        <FormGroup>
                                                                            <Label for="cart_tax_amount_transporter">Cartage Tax Amt</Label>
                                                                            <Input type="number" name="cart_tax_amount_transporter" id="cart_tax_amount_transporter"
                                                                                value={challanMasterData.cart_tax_amount_transporter} onChange={handleChange} disabled />
                                                                        </FormGroup>
                                                                    </Col>



                                                                    <Col sm={3}>
                                                                        <FormGroup>
                                                                            <Label for="cart_amt_with_gst_transporter">Catage Amt with Tax</Label>
                                                                            <Input type="number" name="cart_amt_with_gst_transporter"
                                                                                id="cart_amt_with_gst_transporter" value={challanMasterData.cart_amt_with_gst_transporter}
                                                                                onChange={handleChange} disabled />
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>

                                                            </div>
                                                        </CardBody>
                                                    </Collapse>
                                                </>
                                            }
                                        </div>}


                                        {/* Challan Misc Trans Master Table */}

                                        {system_Records_Issue_Challan_data.chl_acc_misc_yn == "yes" && <div>
                                            {editMode &&
                                                <>
                                                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                                                        style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}
                                                        onClick={() => toggleAccordion(4)}
                                                    >
                                                        <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "red" }}>
                                                            <i className="bi bi-bell mr-2"></i>
                                                            Issue Challan Misc Detail
                                                        </div>
                                                        {openAccordion === 4 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}

                                                    </CardTitle>

                                                    <Collapse isOpen={openAccordion === 4}>


                                                        <CardBody>

                                                            <Row className="">
                                                                <Col sm="4">
                                                                    <FormGroup>
                                                                        <Label for="exp_ac_name">Misc A/C Name
                                                                            <i
                                                                                className="fa fa-plus-circle"
                                                                                onClick={() => { openMiscModal("challan_misc_type") }}
                                                                                style={{ cursor: 'pointer', marginLeft: '10px', color: "blue", fontSize: 20 }}
                                                                            ></i>
                                                                        </Label>
                                                                        <Input type="select" className="custom-select"
                                                                            name="exp_ac_name"
                                                                            id="exp_ac_name"
                                                                            value={challanMiscTransData?.exp_ac_name || ''}
                                                                            onChange={handleChallanMiscTransChange}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            {miscAccountList.map((option) => (
                                                                                <option key={option.id} value={option.name}>
                                                                                    {option.name}
                                                                                </option>
                                                                            ))}
                                                                        </Input>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col sm="3">
                                                                    <FormGroup>

                                                                        <Label for="exp_remarks">Misc Remarks if any</Label>
                                                                        <Input type="text" name="exp_remarks" id="exp_remarks"
                                                                            value={challanMiscTransData?.exp_remarks || ''}
                                                                            onChange={handleChallanMiscTransChange}
                                                                        // disabled={!challanMiscTransData?.exp_ac_name}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col sm="3">
                                                                    <FormGroup>

                                                                        <Label for="exp_amt">Misc Amt</Label>
                                                                        <Input type="number" name="exp_amt" id="exp_amt"
                                                                            value={challanMiscTransData?.exp_amt || ''}
                                                                            onChange={handleChallanMiscTransChange}
                                                                            disabled={!challanMiscTransData?.exp_ac_name}

                                                                        />
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col sm="2" >
                                                                    <Label for="exp_amt">Action</Label>

                                                                    <FormGroup>
                                                                        <Button color="primary" size="sm" onClick={AddChallanMiscData}
                                                                            disabled={!challanMiscTransData.exp_amt}
                                                                        >Save Misc Data</Button>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>

                                                        {challanMiscTransTable.length != 0 && <div>
                                                            <CardBody className="">
                                                                <Table striped>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>S. no.</th>
                                                                            <th>Misc A/C Name</th>
                                                                            <th>Misc Remarks</th>
                                                                            <th>Misc Amt</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {challanMiscTransTable.map((item, index) => (
                                                                            <tr key={index}>
                                                                                <td>{index + 1}</td>
                                                                                <td>{item?.exp_ac_name || ''}</td>
                                                                                <td>{item?.exp_remarks || ''}</td>
                                                                                <td>{item?.exp_amt || ''}</td>
                                                                                <td>
                                                                                    <Button color="danger"
                                                                                        onClick={() => onRemoveChallanMiscData(index)}
                                                                                    >
                                                                                        Remove
                                                                                    </Button>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </Table>
                                                            </CardBody>
                                                        </div>}
                                                    </Collapse>
                                                </>
                                            }
                                        </div>}


                                        {/* Chillan Remak and Document Detail */}

                                        {system_Records_Issue_Challan_data.chl_acc_extra_doc_acc_yn == "yes" && <div>


                                            <RemarkPage

                                                fromName={"remark_detail_document_issue"}
                                                openHelperModal={openHelperModal}
                                                remarkPageArrayList={remarkPageArrayList}
                                                setremarkPageArrayList={setremarkPageArrayList}
                                                deleteRemarkPageArrayList={deleteRemarkPageArrayList}
                                                setDeleteRemarkPageArrayList={setDeleteRemarkPageArrayList}
                                                helperMasterDocumentTypeTable={helperMasterDocumentTypeTable}
                                            />
                                        </div>}

                                        {/* Billing Detail */}

                                        {system_Records_Issue_Challan_data.chl_acc_bill_acc_yn == "yes" && <div>
                                            {editMode &&
                                                <>

                                                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                                                        style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}
                                                        onClick={() => toggleAccordion(5)}
                                                    >
                                                        <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "blue" }}>
                                                            <i className="bi bi-bell mr-2"></i>
                                                            Billing/Accounting Detail
                                                        </div>
                                                        {openAccordion === 5 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}
                                                    </CardTitle>
                                                    <Collapse isOpen={system_Records_Issue_Challan_data.chl_acc_bill_acc_fixed_open_yn == "yes"}>

                                                        <CardBody>


                                                            <div className="App" style={{ padding: '10px' }}>
                                                                <div className='row'>
                                                                 
                                                                    {system_Records_Issue_Challan_data.chl_acc_bill_acc_last_record_yn == "yes" &&
                                                                        <div className="col-lg-7 col-md-12 mb-3">
                                                                            <div
                                                                                style={{
                                                                                    padding: '10px',
                                                                                    overflowY: 'auto',
                                                                                    backgroundColor: '#FFF59D',
                                                                                    borderRadius: 10,
                                                                                    // height: '100%',
                                                                                }}
                                                                            >
                                                                                <h6>Previous Party Challan</h6>
                                                                                {challanLastFiveRecord.length > 0 ?

                                                                                    (challanLastFiveRecord.map((data, index) => (

                                                                                        <div style={{ border: "2px solid #ddd", padding: "10px", marginBottom: "10px", borderRadius: "20px" }}>
                                                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                                                                                    <div style={{ flex: .8 }}>
                                                                                                        <p style={{ margin: "0", fontWeight: "bold" }}>Date:</p>
                                                                                                        <p style={{ margin: "0" }}>{data.bill_date.split('T')[0]}</p>
                                                                                                    </div>
                                                                                                    <div style={{ flex: 2 }}>
                                                                                                        <p style={{ margin: "0", fontWeight: "bold" }}>Name:</p>
                                                                                                        <p style={{ margin: "0", overflow: 'auto', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>({data.agr_code_old}){" "}{data.pname}</p>
                                                                                                    </div>
                                                                                                    <div>
                                                                                                        <Button color="warning" size="sm" onClick={() => { openNewTab(data.id, data.pcode) }}>V</Button>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                                                                                    <div style={{ flex: 1.5 }}>
                                                                                                        <p style={{ margin: "0", fontWeight: "bold" }}>Chl Number:</p>
                                                                                                        <p style={{ margin: "0" }}>{data.manual_billno}</p>
                                                                                                    </div>
                                                                                                    <div style={{ flex: 2 }}>
                                                                                                        <p style={{ margin: "0", fontWeight: "bold" }}>Total Qty:</p>
                                                                                                        <p style={{ margin: "0" }}>{data.tot_qty}</p>
                                                                                                    </div>
                                                                                                    <div style={{ flex: 2 }}>
                                                                                                        <p style={{ margin: "0", fontWeight: "bold" }}>Tot Amt:</p>
                                                                                                        <p style={{ margin: "0" }}>{data.net_amt}</p>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>

                                                                                        </div>
                                                                                    )))
                                                                                    : <>
                                                                                        <p style={{ fontStyle: "normal", color: "#999", textAlign: "center" }}>Data Not Available</p>
                                                                                    </>

                                                                                }



                                                                            </div>
                                                                        </div>}

                                                                    <div className="col-lg-5 col-md-12">
                                                                        <div style={{ padding: '10px' }}>
                                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                                {system_Records_Issue_Challan_data.ch_bill_val_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="gross_amt" >Bill Value</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input style={{ textAlign: "end" }}
                                                                                            type="number" name="gross_amt" id="gross_amt"
                                                                                            // value={challanMasterData.gross_amt || ''}
                                                                                            value={typeof challanMasterData.gross_amt === 'number' ? challanMasterData.gross_amt.toFixed(2) : challanMasterData.gross_amt}
                                                                                            onChange={handleChange} disabled />
                                                                                    </Col>
                                                                                </div>}

                                                                                {system_Records_Issue_Challan_data.ch_tot_qty_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="tot_qty" >Total Qty</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input
                                                                                            style={{ textAlign: "end" }} type="number" name="tot_qty" id="tot_qty"
                                                                                            // value={challanMasterData.tot_qty || ''}
                                                                                            // value={formatNumber(challanMasterData.tot_qty)}
                                                                                            value={typeof challanMasterData.tot_qty === 'number' ? challanMasterData.tot_qty.toFixed(2) : challanMasterData.tot_qty || ''}
                                                                                            onChange={handleChange} disabled />
                                                                                    </Col>
                                                                                </div>}


                                                                                {system_Records_Issue_Challan_data.ch_aprox_qt_wgt_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="apx_weight">Approximate Qty Weight</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input
                                                                                            style={{ textAlign: "end" }} type="number" name="apx_weight" id="apx_weight"
                                                                                            value={typeof challanMasterData.apx_weight === 'number' ? challanMasterData.apx_weight.toFixed(2) : challanMasterData.apx_weight}
                                                                                            onChange={handleChange} disabled />
                                                                                    </Col>
                                                                                </div>}
                                                                                {system_Records_Issue_Challan_data.ch_trip_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="trip_no">Trip No</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input
                                                                                            style={{ textAlign: "end" }} type="number"
                                                                                            name="trip_no" id="trip_no"
                                                                                            value={typeof Number(challanMasterData.trip_no) === 'number' ? Number(challanMasterData.trip_no).toFixed(2) : challanMasterData.trip_no || ''}
                                                                                            onChange={handleChange} disabled />
                                                                                    </Col>
                                                                                </div>}

                                                                                {system_Records_Issue_Challan_data.ch_cartg_amt_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="cart_amt_final">Cartage Amount</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input
                                                                                            style={{ textAlign: "end" }} type="number"
                                                                                            name="cart_amt_final" id="cart_amt_final"
                                                                                            value={typeof challanMasterData.cart_amt_final === 'number' ? challanMasterData.cart_amt_final.toFixed(2) : challanMasterData.cart_amt_final || ''}
                                                                                                                                                               disabled />
                                                                                    </Col>
                                                                                </div>}
                                                                                {system_Records_Issue_Challan_data.mis_exp_tot_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="misc_exp_total">Miscellaneous Expenses Total</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input
                                                                                            style={{ textAlign: "end" }}
                                                                                            type="number"
                                                                                            name="misc_exp_total" id="misc_exp_total"
                                                                                            // value={challanMasterData.misc_exp_total}
                                                                                            value={typeof challanMasterData.misc_exp_total === 'number' ? challanMasterData.misc_exp_total.toFixed(2) : challanMasterData.misc_exp_total || ''}
                                                                                            onChange={handleChange} disabled
                                                                                        />
                                                                                    </Col>
                                                                                </div>}


                                                                                {system_Records_Issue_Challan_data.ch_gross_amt_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="gross_amt_before_tax">Gross amt </Label>
                                                                                    <Col sm={5}>
                                                                                        <Input
                                                                                            style={{ textAlign: "end" }}
                                                                                            type="text"
                                                                                            name="gross_amt_before_tax"
                                                                                            id="gross_amt_before_tax"
                                                                                            // value={challanMasterData.gross_amt_before_tax}
                                                                                            value={typeof challanMasterData.gross_amt_before_tax === 'number' ? challanMasterData.gross_amt_before_tax.toFixed(2) : challanMasterData.gross_amt_before_tax || ''}
                                                                                            disabled
                                                                                            onChange={handleChange}
                                                                                        />

                                                                                    </Col>
                                                                                </div>}


                                                                                {billMethod === "aggrement" && system_Records_Issue_Challan_data.ch_gst_per_yn === "yes" && (
                                                                                    <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                        <Label style={{ width: '150px' }} for="tax_code">GST Tax %</Label>
                                                                                        <Col sm={5}>
                                                                                            <Input

                                                                                                style={{ textAlign: "end" }}
                                                                                                type="text"
                                                                                                name="tax_code"
                                                                                                id="tax_code"
                                                                                                value={typeof challanMasterData.tax_code === 'number' ? challanMasterData.tax_code.toFixed(2) : challanMasterData.tax_code}
                                                                                                onChange={handleChange}
                                                                                            />
                                                                                        </Col>
                                                                                    </div>
                                                                                )}


                                                                                {system_Records_Issue_Challan_data.ch_gst_amt_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="tax_amt">GST Amount</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input style={{ textAlign: "end" }} type="text" name="tax_amt" id="tax_amt"
                                                                                            // value={challanMasterData.tax_amt || ''}
                                                                                            value={typeof challanMasterData.tax_amt === 'number' ? challanMasterData.tax_amt.toFixed(2) : challanMasterData.tax_amt}
                                                                                            disabled
                                                                                            onChange={handleChange} />
                                                                                    </Col>
                                                                                </div>}



                                                                                {system_Records_Issue_Challan_data.ch_gst_type_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="gst_type">GST Type</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input type="text" style={{ textAlign: "end" }} name="gst_type" id="gst_type" value={challanMasterData.gst_type || ''} onChange={handleChange} disabled />
                                                                                    </Col>
                                                                                </div>}
                                                                               
                                                                                {system_Records_Issue_Challan_data.ch_grnd_amt_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="amount_with_gst">Grand Amount</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input type="text" style={{ textAlign: "end" }} name="amount_with_gst" id="amount_with_gst"
                                                                                            // value={challanMasterData.amount_with_gst || ''}}
                                                                                            value={typeof challanMasterData.amount_with_gst === 'number' ? challanMasterData.amount_with_gst.toFixed(2) : challanMasterData.amount_with_gst}
                                                                                            disabled
                                                                                            onChange={handleChange} />
                                                                                    </Col>
                                                                                </div>}



                                                                                {system_Records_Issue_Challan_data.ch_tcs_op_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="cart_tcs_yn">TCS Y/N</Label>
                                                                                    <Col sm={5} xs={7}>
                                                                                        <Input
                                                                                            type="select" className="custom-select"
                                                                                            name="cart_tcs_yn"
                                                                                            id="cart_tcs_yn"
                                                                                            value={challanMasterData.cart_tcs_yn}
                                                                                            onChange={handleChange}
                                                                                        >
                                                                                            {/* <option value="">select</option> */}
                                                                                            <option value="yes">Yes</option>
                                                                                            <option value="no">No</option>

                                                                                        </Input>
                                                                                    </Col>
                                                                                </div>}

                                                                                {system_Records_Issue_Challan_data.ch_tcs_per_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="cart_tcs_percentage">TCS %</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input
                                                                                            style={{ textAlign: "end" }}
                                                                                            type="text"
                                                                                            name="cart_tcs_percentage"
                                                                                            id="cart_tcs_percentage"
                                                                                            value={typeof challanMasterData.cart_tcs_percentage === 'number' ? challanMasterData.cart_tcs_percentage?.toFixed(2) : challanMasterData.cart_tcs_percentage}
                                                                                            disabled={challanMasterData.cart_tcs_yn == "no" || challanMasterData.cart_tcs_yn == ""}
                                                                                            onChange={handleChange}
                                                                                        />
                                                                                    </Col>
                                                                                </div>}

                                                                                {system_Records_Issue_Challan_data.ch_tcs_val_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="cart_tcs_value">TCS Value</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input
                                                                                            style={{ textAlign: "end" }}
                                                                                            type="text"
                                                                                            name="cart_tcs_value"
                                                                                            id="cart_tcs_value"
                                                                                            value={typeof challanMasterData.cart_tcs_value === 'number' ? challanMasterData.cart_tcs_value?.toFixed(2) : challanMasterData.cart_tcs_value || ""}
                                                                                            disabled={challanMasterData.cart_tcs_yn == "no" || challanMasterData.cart_tcs_yn == ""}
                                                                                            onChange={handleChange}
                                                                                        />
                                                                                    </Col>
                                                                                </div>}

                                                                                {system_Records_Issue_Challan_data.ch_grad_amt_w_tcs_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="amount_with_tcs">Grand Amount With Tcs </Label>
                                                                                    <Col sm={5}>
                                                                                        <Input type="text" style={{ textAlign: "end" }} name="amount_with_tcs" id="amount_with_tcs"
                                                                                            // value={challanMasterData.amount_with_tcs || ''}
                                                                                            value={typeof challanMasterData.amount_with_tcs === 'number' ? challanMasterData.amount_with_tcs.toFixed(2) : challanMasterData.amount_with_tcs}
                                                                                            disabled
                                                                                            onChange={handleChange} />
                                                                                    </Col>
                                                                                </div>}





                                                                                {<div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="tds_option">TDS Y/N</Label>
                                                                                    <Col sm={5} xs={7}>
                                                                                        <Input
                                                                                            type="select" className="custom-select"
                                                                                            name="tds_option"
                                                                                            id="tds_option"
                                                                                            value={challanMasterData.tds_option}
                                                                                            onChange={handleChange}
                                                                                        >
                                                                                            {/* <option value="">select</option> */}
                                                                                            <option value="yes">Yes</option>
                                                                                            <option value="no">No</option>

                                                                                        </Input>
                                                                                    </Col>
                                                                                </div>}

                                                                                <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="tds_rate">TDS %</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input type="number" style={{ textAlign: "end" }} name="tds_rate" id="tds_rate"
                                                                                            // value={challanMasterData.tds_amount || ''}
                                                                                            value={typeof challanMasterData.tds_rate === 'number' ? challanMasterData.tds_rate.toFixed(2) : challanMasterData.tds_rate}
                                                                                            onChange={handleChange}
                                                                                            disabled
                                                                                        />
                                                                                    </Col>
                                                                                </div>


                                                                                <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="tds_amount">TDS Amt </Label>
                                                                                    <Col sm={5}>
                                                                                        <Input type="text" style={{ textAlign: "end" }} name="tds_amount" id="tds_amount"
                                                                                            // value={challanMasterData.tds_amount || ''}
                                                                                            value={typeof challanMasterData.tds_amount === 'number' ? challanMasterData.tds_amount.toFixed(2) : challanMasterData.tds_amount}
                                                                                            disabled
                                                                                            onChange={handleChange} />
                                                                                    </Col>
                                                                                </div>

                                                                                {system_Records_Issue_Challan_data?.round_off == "yes" &&

                                                                                    <>

                                                                                        <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                            <Label style={{ width: '150px' }} for="roundoff_yn">Round Off</Label>
                                                                                            <Col sm={5} xs={7}>
                                                                                                <Input type="select" className="custom-select"

                                                                                                    name="roundoff_yn" id="roundoff_yn"
                                                                                                    value={challanMasterData.roundoff_yn}
                                                                                                    onChange={handleChange} >
                                                                                                    <option>select</option>
                                                                                                    <option value="yes">Yes</option>
                                                                                                    <option value="no">No</option>

                                                                                                </Input>
                                                                                            </Col>
                                                                                        </div>
                                                                                        <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                            <Label style={{ width: '150px' }} for="roundoff_amount">Round Off Amount</Label>
                                                                                            <Col sm={5}>
                                                                                                <Input type="text" style={{ textAlign: "end" }} name="roundoff_amount" id="roundoff_amount"
                                                                                                    // value={challanMasterData.roundoff_amount || ''}
                                                                                                    value={typeof challanMasterData.roundoff_amount === 'number' ? challanMasterData.roundoff_amount.toFixed(2) : challanMasterData.roundoff_amount}
                                                                                                    onChange={handleChange}
                                                                                                    disabled />
                                                                                            </Col>
                                                                                        </div>
                                                                                    </>
                                                                                }


                                                                                {system_Records_Issue_Challan_data.ch_fin_amt_yn == "yes" && <div style={{ display: "flex", alignItems: "center", marginBottom: '10px', justifyContent: "flex-end" }}>
                                                                                    <Label style={{ width: '150px' }} for="final_amount">Final Grand Amount</Label>
                                                                                    <Col sm={5}>
                                                                                        <Input type="text" style={{ textAlign: "end" }} name="final_amount" id="final_amount"
                                                                                            // value={challanMasterData.final_amount || ''}
                                                                                            value={typeof challanMasterData.final_amount === 'number' ? challanMasterData.final_amount.toFixed(2) : challanMasterData.final_amount}
                                                                                            onChange={handleChange}
                                                                                            disabled
                                                                                        />
                                                                                    </Col>
                                                                                </div>}


                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                    {/* </div> */}



                                                                </div>
                                                            </div>
                                                        </CardBody>




                                                    </Collapse>



                                                </>
                                            }
                                        </div>
                                        }
                                    </div>}

                                    <CustomModal
                                        show={agreementShowMode}
                                        title={"this is create Aggrement Item Detail"}
                                        onCancel={closeAgrementCustomerModal}
                                        onConfirm={confirmAgrementCustomerModal}
                                        content={
                                            <>
                                                <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
                                                    <div className="d-flex align-items-center">
                                                        <i className="bi bi-bell mr-2"></i>
                                                        Aggrement Item Detail
                                                    </div>
                                                    <Button color="warning" size="bg" onClick={onHandleBackParty} className="ml-auto">
                                                        Back
                                                    </Button>
                                                </CardTitle>

                                                <CardBody>
                                                    <Form>
                                                        <Row>
                                                            <Col md={8}>
                                                                <FormGroup>
                                                                    <Label for="short_name">Item Full Name</Label>

                                                                    <Autocomplete

                                                                        size='small'
                                                                        id="item_name"
                                                                        name="item_name"
                                                                        options={itemTable.map((option) => ({ id: option.id, label: option.item_name }))}
                                                                        renderInput={(params) => <TextField {...params} />}
                                                                        value={agreementData.item_name || ''}
                                                                        onChange={handleOptionSelect}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <Label for="item_short_name">Short Name</Label>
                                                                    <Input
                                                                        id="item_short_name"
                                                                        name="item_short_name"
                                                                        value={agreementData.item_short_name}
                                                                        onChange={onChangeHandle}
                                                                        type="text"
                                                                    // disabled={true}
                                                                    />
                                                                </FormGroup>
                                                            </Col>


                                                        </Row>


                                                        <Row>
                                                            <Col>
                                                                <FormGroup>
                                                                    <Label for="rate_of_one_pcs">Pc/Rmt/Pp</Label>
                                                                    <Input
                                                                        id="rate_of_one_pcs"
                                                                        name="rate_of_one_pcs"
                                                                        value={agreementData.rate_of_one_pcs}
                                                                        onChange={onChangeHandle}
                                                                        type="select" className="custom-select"
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="pc">PC</option>
                                                                        <option value="rmt">RMT</option>
                                                                        <option value="pp">PP</option>

                                                                    </Input>

                                                                </FormGroup>
                                                            </Col>
                                                            <Col>
                                                                <FormGroup>
                                                                    <Label for="agr_qty">Agr Qty.</Label>
                                                                    <Input
                                                                        id="agr_qty"
                                                                        name="agr_qty"
                                                                        value={agreementData.agr_qty}
                                                                        onChange={onChangeHandle}
                                                                        type="tel"
                                                                    // disabled={true}

                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col>
                                                                <FormGroup>
                                                                    <Label for="rent_rate">Rent Rate</Label>
                                                                    <Input
                                                                        id="rent_rate"
                                                                        name="rent_rate"
                                                                        value={agreementData.rent_rate}
                                                                        onChange={onChangeHandle}
                                                                        type="text"
                                                                    // disabled={true}

                                                                    />
                                                                </FormGroup>
                                                            </Col>


                                                            <Col>
                                                                <Label for="missing_rate">Missing</Label>
                                                                <Input
                                                                    id="missing_rate"
                                                                    name="missing_rate"
                                                                    value={agreementData.missing_rate}
                                                                    onChange={onChangeHandle}
                                                                    type="text"
                                                                // disabled={true}

                                                                />
                                                            </Col>

                                                            <Col>
                                                                <FormGroup>
                                                                    <Label for="broken_chg">Damage</Label>
                                                                    <Input
                                                                        id="broken_chg"
                                                                        name="broken_chg"
                                                                        value={agreementData.broken_chg}
                                                                        onChange={onChangeHandle}
                                                                        type="text"
                                                                    // disabled={true}

                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col>
                                                                <FormGroup>
                                                                    <Label for="opening_qty">Opening</Label>
                                                                    <Input
                                                                        id="opening_qty"
                                                                        name="opening_qty"
                                                                        value={agreementData.opening_qty}
                                                                        onChange={onChangeHandle}
                                                                        type="text"
                                                                    // disabled={true}

                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                </CardBody>

                                                {/* <Button color="primary" size="bg" onClick={AddAggrementDetail} className="ms"
                                                disabled={!agreementData.item_name}
                                            >
                                                Add Aggrement Detail
                                            </Button> */}
                                            </>
                                        }
                                    ></CustomModal>

                                    <CustomModal
                                        show={showSingleItemExtraDetailModel}
                                        title={"Add extra detail"}
                                        onCancel={closeSingleItemExtraDetailModel}
                                        // onConfirm={confirmSingleItemExtraDetailModel}
                                        content={<div>
                                            <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                                                style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}

                                                onClick={() => toggleAccordion(2)}>
                                                <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "blue" }}>
                                                    <i className="bi bi-bell mr-2"></i>
                                                    Item Extra Detail ({stockDetail.item_name})
                                                </div>

                                            </CardTitle>

                                            <CardBody
                                            // style={{ backgroundColor: "rgb(179 179 238)" }}
                                            >

                                                <Table>
                                                    <tr style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                        <td style={{ flex: '1 1 calc(25% - 10px)', margin: '5px', boxSizing: 'border-box' }}>
                                                            <FormGroup >
                                                                <Label style={{ fontSize: 14 }} for="item_stock_location">Location</Label>
                                                                <Input
                                                                    id="item_stock_location"
                                                                    name="item_stock_location"
                                                                    type="select" className="custom-select"
                                                                    onChange={(e) => { onChangeStockDetailHandle(e) }}
                                                                    value={stockDetail?.item_stock_location || ""}
                                                                    style={{ fontSize: 14 }}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {locationTable.map((option) => (
                                                                        <option key={option.id} value={option.location_name}>
                                                                            {option.location_name}
                                                                        </option>
                                                                    ))}
                                                                </Input>
                                                            </FormGroup>
                                                        </td>
                                                        {/* <td style={{ flex: '1 1 calc(25% - 10px)', margin: '5px', boxSizing: 'border-box' }}>
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_stock_date">Date</Label>
                                                <Input  
                                                    id="item_stock_date"
                                                    name="item_stock_date"
                                                    type="date"
                                                    onChange={(e) => { onChangeStockDetailHandle(e) }}
                                                    value={stockDetail?.item_stock_date || ""}
                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </td> */}
                                                        <td style={{ flex: '1 1 calc(25% - 10px)', margin: '5px', boxSizing: 'border-box' }}>
                                                            <FormGroup>
                                                                <Label style={{ fontSize: 14 }} for="item_stock_qty">Qty</Label>
                                                                <Input
                                                                    id="item_stock_qty"
                                                                    name="item_stock_qty"
                                                                    type="text"
                                                                    onChange={(e) => { onChangeStockDetailHandle(e) }}
                                                                    value={stockDetail?.item_stock_qty || ""}
                                                                    style={{ fontSize: 14 }}
                                                                />
                                                            </FormGroup>
                                                        </td>
                                                        <td style={{ flex: '1 1 calc(25% - 10px)', margin: '5px', boxSizing: 'border-box' }}>
                                                            <FormGroup>
                                                                <Label style={{ fontSize: 14 }} for="item_stock_rate">Rate</Label>
                                                                <Input
                                                                    id="item_stock_rate"
                                                                    name="item_stock_rate"
                                                                    type="text"
                                                                    onChange={(e) => { onChangeStockDetailHandle(e) }}
                                                                    value={stockDetail?.item_stock_rate || ""}
                                                                    style={{ fontSize: 14 }}
                                                                />
                                                            </FormGroup>
                                                        </td>
                                                        <td style={{ flex: '1 1 calc(25% - 10px)', margin: '5px', boxSizing: 'border-box' }}>
                                                            <FormGroup>
                                                                <Label style={{ fontSize: 14 }} for="item_stock_value">Value of stock</Label>
                                                                <Input
                                                                    id="item_stock_value"
                                                                    name="item_stock_value"
                                                                    type="number"
                                                                    onChange={(e) => { onChangeStockDetailHandle(e) }}
                                                                    value={stockDetail?.item_stock_value || ""}
                                                                    style={{ fontSize: 14 }}
                                                                    disabled
                                                                />
                                                            </FormGroup>
                                                        </td>



                                                        {System_Records_data[0]?.batch_no === "yes" &&
                                                            <td style={{ flex: '1 1 calc(25% - 10px)', margin: '5px', boxSizing: 'border-box' }}>
                                                                <FormGroup>
                                                                    <Label style={{ fontSize: 14 }} for="item_batch_no">Batch/Serial No</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="item_batch_no"
                                                                        id="item_batch_no"
                                                                        value={stockDetail.item_batch_no}
                                                                        onChange={(e) => { onChangeStockDetailHandle(e) }}
                                                                    />
                                                                </FormGroup>
                                                            </td>
                                                        }

                                                        {System_Records_data[0]?.style === "yes" &&
                                                            <td style={{ flex: '1 1 calc(25% - 10px)', margin: '5px', boxSizing: 'border-box' }}>
                                                                <FormGroup>
                                                                    <Label style={{ fontSize: 14 }} for="item_style">Style</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="item_style"
                                                                        id="item_style"
                                                                        value={stockDetail.item_style}
                                                                        onChange={(e) => { onChangeStockDetailHandle(e) }}
                                                                    />
                                                                </FormGroup>
                                                            </td>
                                                        }
                                                        {System_Records_data[0]?.brand === "yes" &&
                                                            <td style={{ flex: '1 1 calc(25% - 10px)', margin: '5px', boxSizing: 'border-box' }}>
                                                                <FormGroup>
                                                                    <Label style={{ fontSize: 14 }} for="item_brand">Brand</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="item_brand"
                                                                        id="item_brand"
                                                                        value={stockDetail.item_brand}
                                                                        onChange={(e) => { onChangeStockDetailHandle(e) }}
                                                                    />
                                                                </FormGroup>
                                                            </td>
                                                        }

                                                        {System_Records_data[0]?.color === "yes" &&
                                                            <td style={{ flex: '1 1 calc(25% - 10px)', margin: '5px', boxSizing: 'border-box' }}>
                                                                <FormGroup>
                                                                    <Label style={{ fontSize: 14 }} for="item_color">Color</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="item_color"
                                                                        id="item_color"
                                                                        value={stockDetail.item_color}
                                                                        onChange={(e) => { onChangeStockDetailHandle(e) }}
                                                                    />
                                                                </FormGroup>
                                                            </td>
                                                        }
                                                        {System_Records_data[0]?.agent === "yes" &&
                                                            <td style={{ flex: '1 1 calc(25% - 10px)', margin: '5px', boxSizing: 'border-box' }}>
                                                                <FormGroup>
                                                                    <Label style={{ fontSize: 14 }} for="item_agent">Agent</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="item_agent"
                                                                        id="item_agent"
                                                                        value={stockDetail.item_agent}
                                                                        onChange={(e) => { onChangeStockDetailHandle(e) }}
                                                                    />
                                                                </FormGroup>
                                                            </td>
                                                        }
                                                        {System_Records_data[0]?.dealer === "yes" &&
                                                            <td style={{ flex: '1 1 calc(25% - 10px)', margin: '5px', boxSizing: 'border-box' }}>
                                                                <FormGroup>
                                                                    <Label style={{ fontSize: 14 }} for="item_dealer">Dealer</Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="item_dealer"
                                                                        id="item_dealer"
                                                                        value={stockDetail.item_dealer}
                                                                        onChange={(e) => { onChangeStockDetailHandle(e) }}
                                                                    />
                                                                </FormGroup>
                                                            </td>
                                                        }
                                                        <td style={{ flex: '1 1 calc(25% - 10px)', margin: '5px', boxSizing: 'border-box', marginTop: 10 }}>
                                                            <Button type="button" style={{ marginTop: 30 }} color="primary" onClick={() => AddStockDetail()}>
                                                                Add Brand Detail
                                                            </Button>
                                                        </td>
                                                    </tr>

                                                </Table>



                                                {stockDetailArray.length != 0 &&
                                                    <>
                                                        <Table bordered style={{ width: '100%', margin: '20px 0', borderCollapse: 'collapse' }}>
                                                            <thead>
                                                                <tr style={{ backgroundColor: '#f8f9fa', textAlign: 'center' }}>
                                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>ID</th>
                                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Location</th>
                                                                    {/* <th style={{ padding: '10px', border: '1px solid #ddd' }}>Date</th> */}
                                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Qty</th>
                                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Rate</th>
                                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Value of Stock</th>
                                                                    {System_Records_data[0]?.batch_no === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Batch No/Serial No</th>}
                                                                    {System_Records_data[0]?.style === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Style</th>}
                                                                    {System_Records_data[0]?.brand === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Brand</th>}
                                                                    {System_Records_data[0]?.color === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Color</th>}
                                                                    {System_Records_data[0]?.agent === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Agent</th>}
                                                                    {System_Records_data[0]?.dealer === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Dealer</th>}
                                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Delete</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {stockDetailArray.map((item, index) => (
                                                                    <tr key={index} style={{ textAlign: 'center' }}>
                                                                        <th scope="row" style={{ padding: '10px', border: '1px solid #ddd' }}>{index + 1}</th>
                                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_stock_location}</td>
                                                                        {/* <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_stock_date}</td> */}
                                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_stock_qty}</td>
                                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_stock_rate}</td>
                                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_stock_value}</td>
                                                                        {System_Records_data[0]?.batch_no === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_batch_no}</td>}
                                                                        {System_Records_data[0]?.style === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_style}</td>}
                                                                        {System_Records_data[0]?.brand === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_brand}</td>}
                                                                        {System_Records_data[0]?.color === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_color}</td>}
                                                                        {System_Records_data[0]?.agent === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_agent}</td>}
                                                                        {System_Records_data[0]?.dealer === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_dealer}</td>}
                                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                                                            <Button
                                                                                color="danger"
                                                                                size="sm"
                                                                                onClick={() => RemoveStockDetail(index)}
                                                                            >
                                                                                Delete
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </>
                                                }
                                            </CardBody>

                                        </div>}
                                    >
                                    </CustomModal>


                                    <CustomModal
                                        show={showSingleItemModel}
                                        title={"Add Item Master detail"}
                                        // onCancel={closeSingleItemModel}
                                        // onConfirm={confirmSingleItemExtraDetailModel}
                                        content={<>
                                            <AddItem onInsert={onInsertSingleItemModel} onCancel={closeSingleItemModel} saleMethod={saleMethod} itemId={challanMasterData.item_code} />

                                            {/* <AddItem onInsert={onInsertSingleItemModel} onCancel={closeSingleItemModel} /> */}
                                        </>}
                                    >
                                    </CustomModal>


                                    {/* model1 */}
                                    <CustomModal
                                        show={openWarrantyVisit}
                                        title={"Add Item Master detail"}
                                        onCancel={ClosedWarrantyModel}
                                        content={<>
                                            <div>
                                                <CardTitle tag="h6" className="border-bottom mb-0 d-flex align-items-center justify-content-between">
                                                    <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "blue", padding: 12 }}>
                                                        <i className="bi bi-bell mr-2"></i>
                                                        Warranty Detail
                                                    </div>
                                                </CardTitle>


                                                <CardBody style={{ padding: 10 }}>
                                                    <Row>
                                                        <Col sm="3">
                                                            <FormGroup>
                                                                <Label for="warranty_period">Item Warranty Period  </Label>
                                                                <Input type="text" name="warranty_period" id="warranty_period"
                                                                    value={warrantySlotDetail?.warranty_period || ''}
                                                                    onChange={handleChallanWarrantyChange}
                                                                />
                                                            </FormGroup>
                                                        </Col>

                                                        <Col sm="3">
                                                            <FormGroup>
                                                                <Label for="warranty_visit_slot">Warranty Visit slot  </Label>
                                                                <Input type="text" name="warranty_visit_slot" id="warranty_visit_slot"
                                                                    value={warrantySlotDetail?.warranty_visit_slot || ''}
                                                                    onChange={handleChallanWarrantyChange}
                                                                />
                                                            </FormGroup>
                                                        </Col>


                                                        <Col sm="3">
                                                            <FormGroup>
                                                                <Label for="warranty_visit_charge">Visit Charge</Label>
                                                                <Input type="select" className="custom-select" name="warranty_visit_charge" id="warranty_visit_charge"
                                                                    value={warrantySlotDetail?.warranty_visit_charge}
                                                                    onChange={handleChallanWarrantyChange}

                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="yes">Yes</option>
                                                                    <option value="no">No</option>
                                                                </Input>
                                                            </FormGroup>
                                                        </Col>


                                                        {/* <Col sm="3">
                                                            <FormGroup>
                                                                <Label for="exp_amt">Warranty Visit  </Label>
                                                                <Input   type="number" name="exp_amt" id="exp_amt"
                                                                // value={challanMiscTransData?.exp_amt || ''}
                                                                // onChange={handleChallanMiscTransChange}
                                                                />
                                                            </FormGroup>
                                                        </Col> */}
                                                        {!viewWarrantyMode && <Col sm="3">
                                                            <FormGroup>
                                                                {/* <Label for="exp_amt">Action</Label> */}
                                                                <Button
                                                                    color="danger"
                                                                    size="sm"
                                                                    onClick={() => calculateWarrantySlotDates()}
                                                                >
                                                                    Check Warranty
                                                                </Button>
                                                            </FormGroup>
                                                        </Col>}
                                                    </Row>
                                                </CardBody>

                                                {warrantySlots.length != 0 &&
                                                    <>
                                                        <Table bordered style={{ width: '100%', margin: '20px 0', borderCollapse: 'collapse' }}>
                                                            <thead>
                                                                <tr style={{ backgroundColor: '#f8f9fa', textAlign: 'center' }}>
                                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Warranty Slot</th>
                                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Warranty Visit Date</th>
                                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Warranty Visit Charge</th>
                                                                    {/* <th style={{ padding: '10px', border: '1px solid #ddd' }}>Value of Stock</th> */}

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {warrantySlots.map((item, index) => (
                                                                    <tr key={index} style={{ textAlign: 'center' }}>
                                                                        <th scope="row" style={{ padding: '10px', border: '1px solid #ddd' }}>{item.warranty_visit_slot}</th>
                                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.warranty_visit_date}</td>
                                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.warranty_visit_charge}</td>
                                                                        {/* <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.warranty_period}</td> */}
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </>
                                                }
                                            </div>

                                        </>}
                                    >
                                    </CustomModal>

                                    {/* Error Model */}
                                    <ErrorModal
                                        show={showErrorModal}
                                        title="Validation / Action Required"
                                        content={errorMessage}
                                        condition={true}
                                        onCancel={() => setShowErrorModal(false)}
                                    // onConfirm={true}
                                    />



                                    <CustomModal
                                        show={miscShowModal}
                                        title={"Add Party Master detail"}
                                        // onCancel={closedMiscModal}
                                        content={<AddParty onCancel={closedMiscModal} onInsert={onInsertMiscPartyModel} partyGroupId={38} partyGroup="MISC. ACCOUNTS For Challan" />}
                                    >
                                    </CustomModal>


                                    {/* Model */}
                                    {/* //================================================================= */}
                                    <CustomerAddHelperMaster show={showHelperModal} fromName={fromName} closedModel={closedHelperModal}
                                        fetchHelperData={fetchHelperData}

                                        vendormasterId={challanMasterData.party_branch_vendor_id}
                                        branchMasterId={challanMasterData.party_branch_master_id}

                                        helperMasterWorkBussinessTable={helperMasterWorkBussinessTable}
                                    />

                                    {/*  Status Model */}
                                    <CustomModal
                                        show={showStatusModel}
                                        title={"Change Status Model"}
                                        size="md"
                                        content={<>
                                            {/* <Card className='bg-white pd-10 card-box mb-30'> */}
                                            <CardTitle
                                                style={{
                                                    backgroundColor: "#f1f3f5",
                                                    borderBottom: "2px solid #007bff",
                                                    padding: "12px 20px",
                                                    borderTopLeftRadius: "8px",
                                                    borderTopRightRadius: "8px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <h5
                                                    style={{
                                                        margin: 0,
                                                        color: "black",
                                                        fontWeight: "bold",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <i className="bi bi-arrow-left-right" style={{ marginRight: "8px" }}></i>
                                                    Change Status
                                                </h5>
                                            </CardTitle>
                                            <CardBody>

                                                <Row>

                                                    <Col xl={6}>
                                                        <FormGroup>
                                                            <Label>Status</Label>
                                                            <Input
                                                                id="status"
                                                                name="status"
                                                                type="select" className="custom-select"
                                                                value={poStatusDetail.status}
                                                                onChange={(e) => handleStatusDetail(e)}
                                                            // disabled={isDisabled}
                                                            >
                                                                <option>Select</option>
                                                                {statusDropdown.map((option) => (
                                                                    <option key={option.id} value={option.field_data}>
                                                                        {option.field_name}
                                                                    </option>
                                                                ))}
                                                            </Input>

                                                            {errorPoStatusMessage.status && (
                                                                <FormText color="danger">{errorPoStatusMessage.status}</FormText>
                                                            )}
                                                        </FormGroup>

                                                        {poStatusDetail.status == "Accepted" &&
                                                            <FormGroup>
                                                                <Label>Exception Date</Label>
                                                                <Input
                                                                    // disabled={ user.user_profile == "customer"}
                                                                    id="exception_date"
                                                                    name="exception_date"
                                                                    type="date"
                                                                    value={poStatusDetail.exception_date}
                                                                    onChange={(e) => handleStatusDetail(e)}
                                                                />

                                                                {errorPoStatusMessage.exception_date && (
                                                                    <FormText color="danger">{errorPoStatusMessage.exception_date}</FormText>
                                                                )}
                                                            </FormGroup>}


                                                        <FormGroup>
                                                            <Label>Remark</Label>
                                                            <Input
                                                                // disabled={ user.user_profile == "customer"}
                                                                id="remark"
                                                                name="remark"
                                                                type="textarea"
                                                                value={poStatusDetail.remark}
                                                                onChange={(e) => handleStatusDetail(e)}
                                                            />

                                                            {errorPoStatusMessage.remark && (
                                                                <FormText color="danger">{errorPoStatusMessage.remark}</FormText>
                                                            )}
                                                        </FormGroup>

                                                        <div className="d-flex justify-content-end gap-2 mt-3">
                                                            <Button color="danger" onClick={closedStatusModel}>Close</Button>
                                                            <Button color="success" onClick={updateStatusDetail}>Update Status</Button>
                                                        </div>

                                                    </Col>

                                                    <Col xl={6}>
                                                        <Col>
                                                            <h5 className="mb-3">Status History</h5>
                                                            <Table bordered hover responsive>
                                                                <thead>
                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th>Status</th>
                                                                        <th>Remark</th>
                                                                        <th>Date</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {chStatusList && chStatusList.length > 0 ? (
                                                                        chStatusList.map((item, index) => (
                                                                            <tr key={index}>
                                                                                <td>{index + 1}</td>
                                                                                {/* <td>{item.labelQtyName}</td> */}
                                                                                <td>{item.po_status}</td>
                                                                                <td>{item.po_status_remark}</td>
                                                                                <td>{item.created_at?.split("T")[0]}</td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="4" className="text-center">
                                                                                No history available
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </Table>
                                                        </Col>

                                                    </Col>
                                                </Row>

                                            </CardBody>



                                        </>}
                                    >
                                    </CustomModal>




                                    {
                                        editMode ?
                                            <>
                                            </>
                                            :
                                            <Button color="success" size="bg" disabled={isSubmitting}
                                                onClick={AddChallanMasterData} className="ms">
                                                <i className="bi bi-save mr-2"></i>
                                                {isLoading ?
                                                    <Loader /> :
                                                    "Save & Continue"}
                                            </Button>

                                    }
                                </Card>
                    </>


            }
        </>
    )
}




export default AddChallanMaster








